import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import toast from "react-hot-toast";
import { useIndiaStateCity } from "../../utils/useIndiaStateCity";
import {
  sanitizeMobileInput,
  getMobileValidationError,
} from "../../utils/mobileInput";
import { getEmailValidationError } from "../../utils/emailInput";
import {
  showMetalGroup,
  showProductGroup,
  createGirviMultipart,
  showGirvi,
  createCustomerUser,
  listCustomerUsers,
  listGirviBanks,
  isErpApiSuccess,
} from "../../erpClient";
import { GIRVI_THEME } from "./girviTheme";
import { useButtonTableStyle } from "../../utils/useButtonTableStyle";
import "./girvi.css";
import CustomerSelection from "../../components/CustomerSelection";
import { hasPermission, PERMISSIONS } from "../../utils/permissions";
import {
  createGirviIdempotencyKey,
  normalizeGirviBanksListResponse,
} from "../../utils/girviErpAdapter";
import { mapCustomerUsersToPartyList } from "../../utils/customerUsersErpAdapter";
import { searchProductGroupSelectOptions } from "../../utils/productGroupOptions";

// Same COLUMNS structure as Sales.jsx
const COLUMNS = [
  { id: "no", label: "No.", width: "20px" },
  {
    id: "productGroup",
    label: (
      <>
        Product Group 
      </>
    ),
    width: "250px",
  },
  {
    id: "purity", label: (
      <>
        Purity 
      </>
    ), width: "80px"
  },
  { id: "pcs", label: "Pcs", width: "60px" },
  {
    id: "grWt",
    label: (
      <>
        Gr.Wt 
      </>
    ),
    width: "70px",
  },
  { id: "lsWt", label: "Ls.Wt", width: "70px" },
  { id: "netWt", label: "Net.Wt", width: "70px" },
  {
    id: "fWt", label: (
      <>
        Fine.Wt 
      </>
    ), width: "70px"
  },
  { id: "itRateOn", label: "RateOn", width: "100px" },
  { id: "itRate", label: "Rate", width: "100px" },
  {
    id: "itAmt", label: (
      <>
        Amount 
      </>
    ), width: "100px"
  },
  { id: "othAmt", label: "Other", width: "120px" },
  { id: "mrp", label: "MRP", width: "100px" },
  { id: "totalAmt", label: "TotalAmt", width: "150px" },
];

const AVAILABLE_PAYMENT_METHODS = [
  "cash",
  "cheque",
  "bank_transfer",
  "upi",
  "card",
  "old_gold",
  "old_silver",
  "kasar",
  "scheme",
  "order",
];

const PAYMENT_METHOD_LABELS = {
  cash: "Cash",
  cheque: "Cheque",
  bank_transfer: "Bank Transfer",
  upi: "UPI",
  card: "Card",
  old_gold: "Old Gold",
  old_silver: "Old Silver",
  kasar: "Kasar",
  scheme: "Scheme",
  order: "Order",
};

const PAYMENT_COLUMNS = [
  { id: "no", label: "No.", width: "30px" },
  { id: "pay_mode", label: "Mode", width: "140px" },
  { id: "type", label: "Type", width: "140px" },
  { id: "remarks", label: "Remarks", width: "180px" },
  { id: "amount", label: "Amt", width: "110px" },
];

function AddGirvi({ masterGoldRate, masterSilverRate }) {
  const navigate = useNavigate();
  const { buttonClass, tableClass, cardClass, buttonTableStyle } =
    useButtonTableStyle();

  const canCreateGirvi = hasPermission(PERMISSIONS.ADDGIRVI);
  const girviCreateIdempotencyKeyRef = useRef(null);
  const girviCreatePayloadFingerprintRef = useRef(null);

  const initialRowData = COLUMNS.map((col) => ({
    id: col.id,
    value: col.id === "itRateOn" ? "FWt" : "",
    isManual: false, // Flag for manual edits
  }));

  const [tableData, setTableData] = useState([
    {
      id: 1,
      data: initialRowData.map((cell) => ({
        ...cell,
        displayValue: cell.id === "productGroup" ? "" : undefined,
      })),
    },
    {
      id: 2,
      data: initialRowData.map((cell) => ({
        ...cell,
        displayValue: cell.id === "productGroup" ? "" : undefined,
      })),
    },
  ]);
  const [paymentRows, setPaymentRows] = useState([
    { id: 1, pay_mode: "cash", type: "", remarks: "", amount: "0.00" },
    { id: 2, pay_mode: "cheque", type: "", remarks: "", amount: "0.00" },
    { id: 3, pay_mode: "bank_transfer", type: "", remarks: "", amount: "0.00" },
  ]);
  const [productGroups, setProductGroups] = useState([]);
  const [girviBanks, setGirviBanks] = useState([]);
  const customerSearchCacheRef = useRef(new Set());
  const lastSearchedProductGroupPrefixRef = useRef("");
  const girviBanksLoadPromiseRef = useRef(null);
  const [billType, setBillType] = useState("GST");
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [customerMobile, setCustomerMobile] = useState("");
  const [customerMobileSearchText, setCustomerMobileSearchText] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerNameSearchText, setCustomerNameSearchText] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [customerMobileDropdownActive, setCustomerMobileDropdownActive] =
    useState(false);
  const [customerMobileHighlightedIndex, setCustomerMobileHighlightedIndex] =
    useState(0);
  const customerMobileInputRef = useRef(null);
  const customerMobileDropdownRef = useRef(null);
  const customerMobileItemsRef = useRef([]);
  const [userss, setUserss] = useState([]);
  const [customerPhoto, setCustomerPhoto] = useState(null);
  const [customerPhotoPreview, setCustomerPhotoPreview] = useState(null);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const customerPhotoInputRef = useRef(null);
  const [itemImage, setItemImage] = useState(null);
  const [itemImagePreview, setItemImagePreview] = useState(null);
  const [showItemImageModal, setShowItemImageModal] = useState(false);
  const itemImageInputRef = useRef(null);
  const [showItemsModal, setShowItemsModal] = useState(false);
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerDetails, setCustomerDetails] = useState({
    email: "",
    birthDate: "",
    anniversaryDate: "",
    companyName: "",
    companyAddress: "",
    gstNumber: "",
    aadharNo: "",
    panNo: "",
    maritalStatus: "",
    balance: "",
    saleBalance: "",
    reference: "",
    state: "",
    area: "",
  });
  const [customerCity, setCustomerCity] = useState("");
  const [customerSaveSuccess, setCustomerSaveSuccess] = useState(false);
  const { states, cities, selectedState, setSelectedState } = useIndiaStateCity();

  // Product Group dropdown states (per row)
  const [productGroupDropdownActive, setProductGroupDropdownActive] = useState(
    {},
  );
  const [productGroupSearchText, setProductGroupSearchText] = useState({});
  const [productGroupHighlightedIndex, setProductGroupHighlightedIndex] =
    useState({});
  const productGroupInputRefs = useRef({});
  const productGroupDropdownRefs = useRef({});
  const productGroupItemsRefs = useRef({});

  // ItRateOn dropdown states (per row)
  const itRateOnOptions = ["FWt", "NWt", "GWt"];
  const DEFAULT_RATE_ON = "FWt";
  const [itRateOnDropdownActive, setItRateOnDropdownActive] = useState({});
  const [itRateOnSearchText, setItRateOnSearchText] = useState({});
  const [itRateOnHighlightedIndex, setItRateOnHighlightedIndex] = useState({});
  const itRateOnInputRefs = useRef({});
  const itRateOnDropdownRefs = useRef({});
  const itRateOnItemsRefs = useRef({});

  // Get filtered product groups by search text
  const getFilteredProductGroups = (searchText, rowId) => {
    // Only show results when user types something (don't show all groups)
    if (!searchText || !searchText.trim() || searchText.trim().length < 3)
      return [];
    // After 3+ characters, productGroups has already been fetched from API with search filter
    return productGroups;
  };

  // Handle Product Group input change — search API at 3+ chars (same as Add Purchase)
  const handleProductGroupChange = (rowId, value) => {
    setProductGroupSearchText((prev) => ({ ...prev, [rowId]: value }));
    setProductGroupDropdownActive((prev) => ({ ...prev, [rowId]: true }));
    setProductGroupHighlightedIndex((prev) => ({ ...prev, [rowId]: 0 }));

    // If user clears the input, erase the selected product group and reset dependent fields
    if (!value || !value.trim()) {
      lastSearchedProductGroupPrefixRef.current = "";
      setProductGroups([]);
      const rowIndex = tableData.findIndex((r) => r.id === rowId);
      if (rowIndex !== -1) {
        setTableData((prevData) => {
          const updated = [...prevData];
          const pgCell = updated[rowIndex].data.find(
            (c) => c.id === "productGroup",
          );
          if (pgCell) {
            pgCell.value = "";
            pgCell.displayValue = "";
          }
          const purityCell = updated[rowIndex].data.find(
            (c) => c.id === "purity",
          );
          if (purityCell) {
            purityCell.value = "";
          }
          const itRateCell = updated[rowIndex].data.find(
            (c) => c.id === "itRate",
          );
          if (itRateCell) {
            itRateCell.value = "";
          }
          const itAmtCell = updated[rowIndex].data.find(
            (c) => c.id === "itAmt",
          );
          if (itAmtCell) {
            itAmtCell.value = "";
            itAmtCell.isManual = false;
          }
          const totalAmtCell = updated[rowIndex].data.find(
            (c) => c.id === "totalAmt",
          );
          if (totalAmtCell) {
            totalAmtCell.value = "";
            totalAmtCell.isManual = false;
          }
          updated[rowIndex].userOverrodeItRate = false;
          return updated;
        });
      }
      setProductGroupDropdownActive((prev) => ({ ...prev, [rowId]: false }));
      return;
    }

    if (value.trim().length < 3) {
      lastSearchedProductGroupPrefixRef.current = "";
      setProductGroups([]);
      return;
    }

    const query = value.trim();
    if (lastSearchedProductGroupPrefixRef.current === query) return;

    (async () => {
      try {
        const opts = await searchProductGroupSelectOptions(query);
        lastSearchedProductGroupPrefixRef.current = query;
        const productGroupsList = (opts || []).map((group) => {
          const label = group.label || group.name || "";
          let metalType = group.metal || "";
          if (!metalType) {
            const lower = label.toLowerCase();
            if (lower.includes("gold")) metalType = "Gold";
            else if (lower.includes("silver")) metalType = "Silver";
            else if (lower.includes("platinum")) metalType = "Platinum";
          }
          return {
            value: String(group.value ?? group.id),
            label,
            id: group.value ?? group.id,
            searchText: label.toLowerCase(),
            metal: metalType,
            purity: group.purity || "",
            touch: group.touch || "",
            metal_group_id: group.metal_group_id ?? null,
          };
        });
        setProductGroups(productGroupsList);
      } catch (error) {
        console.error("Error searching product groups:", error);
        setProductGroups([]);
      }
    })();
  };

  // Calculate rate based on purity
  const calculatePurityBasedRate = (purity, rate, metalType) => {
    // Extract the karat/purity value from string (e.g. "18K" -> 18 or "925" -> 925)
    const purityValue = parseFloat(purity);
    if (isNaN(purityValue)) return rate;

    if (metalType === "Gold") {
      const basePerGram = rate / 10;
      const factor = purityValue > 24 ? purityValue / 100 : purityValue / 24;
      return basePerGram * factor;
    } else if (metalType === "Silver") {
      return (rate * purityValue) / 999;
    }

    return rate;
  };

  const calculatePerGramRate = (rate, metalType) => {
    return rate;
  };

  // Calculate Total Amount for a row
  const calculateTotalAmount = (data, rowIndex) => {
    const row = data[rowIndex];
    const itAmt =
      parseFloat(row.data.find((c) => c.id === "itAmt")?.value) || 0;
    const othAmt =
      parseFloat(row.data.find((c) => c.id === "othAmt")?.value) || 0;

    // Calculate total
    const total = itAmt + othAmt;

    // Update totalAmt cell
    const totalAmtCell = row.data.find((c) => c.id === "totalAmt");
    if (totalAmtCell) {
      totalAmtCell.value = total.toFixed(2);
    }

    return data;
  };

  // Helper function to calculate and update itRate for a row based on product group
  const calculateAndUpdateItRate = (
    tableData,
    rowIndex,
    groupsOverride = null,
  ) => {
    let newTableData = [...tableData];
    const productGroupCell = newTableData[rowIndex].data.find(
      (cell) => cell.id === "productGroup",
    );

    let computedRatePerGram = 0;
    let hasProductGroup = false;

    const groups =
      groupsOverride && Array.isArray(groupsOverride)
        ? groupsOverride
        : productGroups;

    // Safety check: return unchanged data if productGroups is not ready
    if (!groups || !Array.isArray(groups)) {
      return newTableData;
    }

    // Find the selected product group object to get its purity if it exists
    if (productGroupCell && productGroupCell.value) {
      const selectedProductGroup = groups.find(
        (pg) => pg.value === String(productGroupCell.value),
      );

      const purityCell = newTableData[rowIndex].data.find(
        (c) => c.id === "purity",
      );
      const effectivePurity =
        purityCell && purityCell.value
          ? purityCell.value
          : selectedProductGroup?.touch || selectedProductGroup?.purity;

      if (selectedProductGroup) {
        hasProductGroup = true;
        if (selectedProductGroup.metal === "Gold") {
          if (Array.isArray(masterGoldRate)) {
            const purityStr = (effectivePurity || "").toString();
            const labelStr = (selectedProductGroup.label || "").toLowerCase();
            let idx = 0;
            if (labelStr.includes("rose")) {
              idx = 3;
            } else {
              const purityNum = parseFloat(purityStr);
              let carat = 24;
              if (!isNaN(purityNum)) {
                const isPercent = purityNum > 24;
                const approxCarat = isPercent
                  ? Math.round((purityNum * 24) / 100)
                  : Math.round(purityNum);
                if (
                  approxCarat === 18 ||
                  approxCarat === 22 ||
                  approxCarat === 24
                ) {
                  carat = approxCarat;
                } else {
                  if (labelStr.includes("18")) carat = 18;
                  else if (labelStr.includes("22")) carat = 22;
                  else carat = 24;
                }
              } else {
                if (labelStr.includes("18")) carat = 18;
                else if (labelStr.includes("22")) carat = 22;
                else carat = 24;
              }
              if (carat === 22) idx = 1;
              else if (carat === 18) idx = 2;
              else idx = 0;
            }
            const ratePerGram = Number(masterGoldRate[idx] || 0);
            computedRatePerGram = ratePerGram;
          } else {
            const baseRate = masterGoldRate;
            if (effectivePurity) {
              computedRatePerGram = calculatePurityBasedRate(
                effectivePurity,
                baseRate,
                "Gold",
              );
            } else {
              computedRatePerGram = calculatePerGramRate(baseRate, "Gold");
            }
          }
        } else {
          const baseRate = masterSilverRate;
          if (effectivePurity) {
            computedRatePerGram = calculatePurityBasedRate(
              effectivePurity,
              baseRate,
              "Silver",
            );
          } else {
            computedRatePerGram = calculatePerGramRate(baseRate, "Silver");
          }
        }
      }
    }

    // Find and update the itRate cell
    const itRateCell = newTableData[rowIndex].data.find(
      (cell) => cell.id === "itRate",
    );

    if (itRateCell) {
      const isOverridden = newTableData[rowIndex].userOverrodeItRate;
      let effectiveRate = 0;

      if (hasProductGroup) {
        effectiveRate = isOverridden
          ? parseFloat(itRateCell.value) || 0
          : computedRatePerGram;

        if (!isOverridden) {
          itRateCell.value = computedRatePerGram.toFixed(2);
        }
      } else {
        // If no product group, just use the current value in the cell
        effectiveRate = parseFloat(itRateCell.value) || 0;
      }

      // Recalculate itAmt after updating/using effective itRate
      const itRateOnCell = newTableData[rowIndex].data.find(
        (cell) => cell.id === "itRateOn",
      );
      const netWtCell = newTableData[rowIndex].data.find(
        (cell) => cell.id === "netWt",
      );
      const grWtCell = newTableData[rowIndex].data.find(
        (cell) => cell.id === "grWt",
      );
      const fWtCell = newTableData[rowIndex].data.find(
        (cell) => cell.id === "fWt",
      );

      if (itRateOnCell && (netWtCell || grWtCell || fWtCell)) {
        const itRateOn = (itRateOnCell.value || DEFAULT_RATE_ON).toUpperCase();
        const netWt = parseFloat(netWtCell?.value) || 0;
        const grWt = parseFloat(grWtCell?.value) || 0;
        const fWt = parseFloat(fWtCell?.value) || 0;

        let baseWeight = fWt;
        if (itRateOn === "GWT") baseWeight = grWt;
        else if (itRateOn === "NWT") baseWeight = netWt;
        else baseWeight = fWt; // FWt (default)

        const itAmt = (baseWeight * effectiveRate).toFixed(2);
        const itAmtCell = newTableData[rowIndex].data.find(
          (cell) => cell.id === "itAmt",
        );
        if (itAmtCell) {
          itAmtCell.value = itAmt.toString();
        }

        // Recalculate Total Amount
        calculateTotalAmount(newTableData, rowIndex);
      }
    }

    return newTableData;
  };

  // Handle Product Group selection — then load metal_group by id for purity
  const handleProductGroupSelect = async (rowId, selectedGroup) => {
    const rowIndex = tableData.findIndex((r) => r.id === rowId);
    if (rowIndex === -1) return;

    const colIndex = tableData[rowIndex].data.findIndex(
      (c) => c.id === "productGroup",
    );
    if (colIndex === -1) return;

    let purityValue = selectedGroup.touch || selectedGroup.purity || "";
    let metalType = selectedGroup.metal || "";
    let metalGroupId = selectedGroup.metal_group_id;

    if (!metalGroupId && selectedGroup.value) {
      try {
        const pgRes = await showProductGroup({
          id: Number(selectedGroup.value),
        });
        const pg = pgRes?.data?.product_group ?? pgRes?.data;
        if (isErpApiSuccess(pgRes) && pg?.metal_group_id) {
          metalGroupId = pg.metal_group_id;
        }
      } catch (error) {
        console.error("Error fetching product group detail:", error);
      }
    }

    if (metalGroupId) {
      try {
        const mgRes = await showMetalGroup({ id: Number(metalGroupId) });
        const mg = mgRes?.data?.metal_group ?? mgRes?.data;
        if (isErpApiSuccess(mgRes) && mg) {
          purityValue =
            mg.touch ??
            mg.Touch ??
            mg.purity ??
            mg.Purity ??
            mg.carat ??
            mg.Carat ??
            purityValue;
          const metalRaw = String(mg.metal ?? mg.Metal ?? "").toLowerCase();
          if (metalRaw === "gold") metalType = "Gold";
          else if (metalRaw === "silver") metalType = "Silver";
          else if (metalRaw === "platinum") metalType = "Platinum";
          else if (mg.metal || mg.Metal) metalType = mg.metal || mg.Metal;
        }
      } catch (error) {
        console.error("Error fetching metal group purity:", error);
      }
    }

    const enrichedGroup = {
      ...selectedGroup,
      metal: metalType,
      purity: purityValue,
      touch: purityValue,
    };

    setProductGroups((prev) => {
      const next = Array.isArray(prev) ? [...prev] : [];
      const idx = next.findIndex(
        (pg) => String(pg.value) === String(enrichedGroup.value),
      );
      if (idx >= 0) next[idx] = { ...next[idx], ...enrichedGroup };
      else next.push(enrichedGroup);
      return next;
    });

    setTableData((prevData) => {
      let updatedData = [...prevData];
      const cell = updatedData[rowIndex].data[colIndex];
      cell.value = selectedGroup.value;
      cell.displayValue = selectedGroup.label;

      const purityCell = updatedData[rowIndex].data.find(
        (c) => c.id === "purity",
      );
      if (purityCell) {
        purityCell.value = purityValue;
      }

      updatedData = calculateAndUpdateItRate(updatedData, rowIndex, [
        enrichedGroup,
        ...(Array.isArray(productGroups) ? productGroups : []),
      ]);
      // After purity is set from product group, recompute NWT / FWT
      {
        const r = updatedData[rowIndex];
        const gr = r.data.find((c) => c.id === "grWt")?.value || "";
        const ls = r.data.find((c) => c.id === "lsWt")?.value || "";
        const netWtCell = r.data.find((c) => c.id === "netWt");
        const net = calculateNetWeight(gr, ls);
        if (netWtCell) {
          netWtCell.value = net > 0 ? net.toFixed(3) : "";
        }
        updateFineWeightCell(r);
      }
      return updatedData;
    });

    setProductGroupSearchText((prev) => ({
      ...prev,
      [rowId]: selectedGroup.label,
    }));
    setProductGroupDropdownActive((prev) => ({ ...prev, [rowId]: false }));

    const nextInput = productGroupInputRefs.current[rowId]
      ?.closest("tr")
      ?.querySelector('input[type="number"]');
    if (nextInput) {
      nextInput.focus();
    }
  };

  // Handle Product Group keyboard navigation
  const handleProductGroupKeyDown = (e, rowId) => {
    const searchText = productGroupSearchText[rowId] || "";
    const filtered = getFilteredProductGroups(searchText, rowId);

    if (!productGroupDropdownActive[rowId] || filtered.length === 0) {
      if (e.key === "Enter" || e.key === "Tab") {
        // Move to next field
        const nextInput = e.target
          .closest("tr")
          ?.querySelector('input[type="number"]');
        if (nextInput) {
          nextInput.focus();
        }
      }
      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setProductGroupHighlightedIndex((prev) => ({
          ...prev,
          [rowId]: Math.min((prev[rowId] || 0) + 1, filtered.length - 1),
        }));
        break;
      case "ArrowUp":
        e.preventDefault();
        setProductGroupHighlightedIndex((prev) => ({
          ...prev,
          [rowId]: Math.max((prev[rowId] || 0) - 1, 0),
        }));
        break;
      case "Enter":
        e.preventDefault();
        if (
          filtered.length > 0 &&
          productGroupHighlightedIndex[rowId] !== undefined
        ) {
          handleProductGroupSelect(
            rowId,
            filtered[productGroupHighlightedIndex[rowId]],
          );
        }
        break;
      case "Escape":
        e.preventDefault();
        setProductGroupDropdownActive((prev) => ({ ...prev, [rowId]: false }));
        break;
      case "Tab":
        setProductGroupDropdownActive((prev) => ({ ...prev, [rowId]: false }));
        break;
      default:
        break;
    }
  };

  // Render Product Group dropdown
  const renderProductGroupDropdown = (rowId) => {
    if (!productGroupDropdownActive[rowId]) return null;

    const searchText = productGroupSearchText[rowId] || "";
    const filtered = getFilteredProductGroups(searchText, rowId);

    // Only show dropdown if there are filtered results
    if (filtered.length === 0) return null;

    // If search text is empty, don't show dropdown (user needs to type to search)
    if (!searchText.trim()) return null;

    const inputElement = productGroupInputRefs.current[rowId];
    if (!inputElement) return null;

    const inputWidth = inputElement.offsetWidth;
    const inputRect = inputElement.getBoundingClientRect();

    if (!inputRect) return null;

    // Calculate height for exactly 5 items (similar to CustomOrderEntry.jsx pattern)
    // Each item: padding 0.5rem top + 0.5rem bottom = 1rem = ~16px, plus text height ~24px = ~40px per item
    // 5 items = 5 * 40px = 200px
    const maxVisibleItems = 5;
    const itemHeight = 40; // Approximate height per item in pixels
    const scrollableHeight = maxVisibleItems * itemHeight; // 200px for 5 items

    return ReactDOM.createPortal(
      <div
        ref={(el) => (productGroupDropdownRefs.current[rowId] = el)}
        className="dropdown-menu show shadow-sm girvi-customer-dropdown"
        style={{
          position: "fixed",
          top: `${inputRect.bottom}px`,
          left: `${inputRect.left}px`,
          width: `${Math.max(inputWidth, 200)}px`,
          minWidth: `${Math.max(inputWidth, 200)}px`,
          maxWidth: `${Math.max(inputWidth, 200)}px`,
          maxHeight: `${scrollableHeight + 16}px`, // Add padding for outer container
          overflowY: "hidden", // Outer container doesn't scroll
          zIndex: 9999,
          border: "none",
          borderRadius: "0.5rem",
          padding: "0.5rem 0",
          backgroundColor: "#fff",
          fontSize: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        }}
      >
        <div
          style={{
            maxHeight: `${scrollableHeight}px`,
            height: `${scrollableHeight}px`,
            overflowY: filtered.length > maxVisibleItems ? "auto" : "hidden",
            overflowX: "hidden",
          }}
        >
          {filtered.length > 0 ? (
            filtered.map((group, idx) => (
              <div
                key={group.value}
                ref={(el) => {
                  if (!productGroupItemsRefs.current[rowId]) {
                    productGroupItemsRefs.current[rowId] = [];
                  }
                  productGroupItemsRefs.current[rowId][idx] = el;
                }}
                className="dropdown-item"
                style={{
                  cursor: "pointer",
                  padding: "0.5rem 1rem",
                  fontSize: "0.85rem",
                  backgroundColor:
                    idx === (productGroupHighlightedIndex[rowId] || 0)
                      ? "var(--theme-primary)"
                      : "transparent",
                  color:
                    idx === (productGroupHighlightedIndex[rowId] || 0)
                      ? "#fff"
                      : "inherit",
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  transition: "background-color 0.2s, color 0.2s",
                }}
                onMouseEnter={() =>
                  setProductGroupHighlightedIndex((prev) => ({
                    ...prev,
                    [rowId]: idx,
                  }))
                }
                onMouseDown={() => handleProductGroupSelect(rowId, group)}
              >
                {group.label}
              </div>
            ))
          ) : (
            <div
              className="dropdown-item disabled"
              style={{
                padding: "0.5rem 1rem",
                fontSize: "0.85rem",
                textAlign: "center",
                color: "#999",
              }}
            >
              No matching items
            </div>
          )}
        </div>
      </div>,
      document.getElementById("dropdown-portal") || document.body,
    );
  };

  // Get filtered ItRateOn options
  const getFilteredItRateOnOptions = (searchText) => {
    if (!searchText) return itRateOnOptions;
    const searchLower = searchText.toLowerCase();
    return itRateOnOptions.filter((option) =>
      option.toLowerCase().includes(searchLower),
    );
  };

  // Handle ItRateOn input change
  const handleItRateOnChange = (rowId, value) => {
    setItRateOnSearchText((prev) => ({ ...prev, [rowId]: value }));
    setItRateOnDropdownActive((prev) => ({ ...prev, [rowId]: true }));
    setItRateOnHighlightedIndex((prev) => ({ ...prev, [rowId]: 0 }));
  };

  // Handle ItRateOn selection
  const handleItRateOnSelect = (rowId, selectedOption) => {
    const rowIndex = tableData.findIndex((r) => r.id === rowId);
    if (rowIndex !== -1) {
      const colIndex = tableData[rowIndex].data.findIndex(
        (c) => c.id === "itRateOn",
      );
      if (colIndex !== -1) {
        setTableData((prevData) => {
          let updatedData = [...prevData];
          const cell = updatedData[rowIndex].data[colIndex];
          cell.value = selectedOption;

          // Recalculate based on new RateOn
          updatedData = calculateAndUpdateItRate(updatedData, rowIndex);

          return updatedData;
        });
      }
    }

    setItRateOnSearchText((prev) => ({ ...prev, [rowId]: selectedOption }));
    setItRateOnDropdownActive((prev) => ({ ...prev, [rowId]: false }));

    // Move focus to next field
    const nextInput = itRateOnInputRefs.current[rowId]
      ?.closest("tr")
      ?.querySelector('input[type="number"]');
    if (nextInput) {
      nextInput.focus();
    }
  };

  // Handle ItRateOn keyboard navigation
  const handleItRateOnKeyDown = (e, rowId) => {
    const searchText = itRateOnSearchText[rowId] || "";
    const filtered = getFilteredItRateOnOptions(searchText);

    if (!itRateOnDropdownActive[rowId] || filtered.length === 0) {
      if (e.key === "Enter" || e.key === "Tab") {
        const nextInput = e.target
          .closest("tr")
          ?.querySelector('input[type="number"]');
        if (nextInput) {
          nextInput.focus();
        }
      }
      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setItRateOnHighlightedIndex((prev) => ({
          ...prev,
          [rowId]: Math.min((prev[rowId] || 0) + 1, filtered.length - 1),
        }));
        break;
      case "ArrowUp":
        e.preventDefault();
        setItRateOnHighlightedIndex((prev) => ({
          ...prev,
          [rowId]: Math.max((prev[rowId] || 0) - 1, 0),
        }));
        break;
      case "Enter":
        e.preventDefault();
        if (
          filtered.length > 0 &&
          itRateOnHighlightedIndex[rowId] !== undefined
        ) {
          handleItRateOnSelect(
            rowId,
            filtered[itRateOnHighlightedIndex[rowId]],
          );
        }
        break;
      case "Escape":
        e.preventDefault();
        setItRateOnDropdownActive((prev) => ({ ...prev, [rowId]: false }));
        break;
      case "Tab":
        setItRateOnDropdownActive((prev) => ({ ...prev, [rowId]: false }));
        break;
      default:
        break;
    }
  };

  // Render ItRateOn dropdown
  const renderItRateOnDropdown = (rowId) => {
    if (!itRateOnDropdownActive[rowId]) return null;

    const searchText = itRateOnSearchText[rowId] || "";
    const filtered = getFilteredItRateOnOptions(searchText);

    if (filtered.length === 0) return null;

    const inputElement = itRateOnInputRefs.current[rowId];
    if (!inputElement) return null;

    const inputWidth = inputElement.offsetWidth;
    const inputRect = inputElement.getBoundingClientRect();

    if (!inputRect) return null;

    return ReactDOM.createPortal(
      <div
        ref={(el) => (itRateOnDropdownRefs.current[rowId] = el)}
        className="dropdown-menu show shadow-sm girvi-customer-dropdown"
        style={{
          position: "fixed",
          top: `${inputRect.bottom}px`,
          left: `${inputRect.left}px`,
          width: `${inputWidth}px`,
          minWidth: `${inputWidth}px`,
          maxWidth: `${inputWidth}px`,
          maxHeight: "200px",
          overflowY: "auto",
          zIndex: 9999,
          border: "none",
          borderRadius: "0.5rem",
          padding: "0.5rem 0",
          backgroundColor: "#fff",
          fontSize: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        }}
      >
        {filtered.map((option, idx) => (
          <div
            key={option}
            ref={(el) => {
              if (!itRateOnItemsRefs.current[rowId]) {
                itRateOnItemsRefs.current[rowId] = [];
              }
              itRateOnItemsRefs.current[rowId][idx] = el;
            }}
            className="dropdown-item"
            style={{
              cursor: "pointer",
              padding: "0.5rem 1rem",
              fontSize: "0.85rem",
              backgroundColor:
                idx === (itRateOnHighlightedIndex[rowId] || 0)
                  ? "var(--theme-primary)"
                  : "transparent",
              color:
                idx === (itRateOnHighlightedIndex[rowId] || 0)
                  ? GIRVI_THEME.textColor
                  : "inherit",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              transition: "background-color 0.2s, color 0.2s",
            }}
            onMouseEnter={() =>
              setItRateOnHighlightedIndex((prev) => ({ ...prev, [rowId]: idx }))
            }
            onMouseDown={() => handleItRateOnSelect(rowId, option)}
          >
            {option}
          </div>
        ))}
      </div>,
      document.getElementById("dropdown-portal") || document.body,
    );
  };

  // Handle click outside for product group dropdowns
  useEffect(() => {
    function handleClickOutside(event) {
      // Handle customer mobile dropdown
      if (
        customerMobileDropdownRef.current &&
        !customerMobileDropdownRef.current.contains(event.target) &&
        customerMobileInputRef.current &&
        !customerMobileInputRef.current.contains(event.target)
      ) {
        setCustomerMobileDropdownActive(false);
      }

      // Handle product group dropdowns
      Object.keys(productGroupDropdownActive).forEach((rowId) => {
        if (productGroupDropdownActive[rowId]) {
          const dropdownRef = productGroupDropdownRefs.current[rowId];
          const inputRef = productGroupInputRefs.current[rowId];

          if (
            dropdownRef &&
            !dropdownRef.contains(event.target) &&
            inputRef &&
            !inputRef.contains(event.target)
          ) {
            setProductGroupDropdownActive((prev) => ({
              ...prev,
              [rowId]: false,
            }));
          }
        }
      });

      // Handle ItRateOn dropdowns
      Object.keys(itRateOnDropdownActive).forEach((rowId) => {
        if (itRateOnDropdownActive[rowId]) {
          const dropdownRef = itRateOnDropdownRefs.current[rowId];
          const inputRef = itRateOnInputRefs.current[rowId];

          if (
            dropdownRef &&
            !dropdownRef.contains(event.target) &&
            inputRef &&
            !inputRef.contains(event.target)
          ) {
            setItRateOnDropdownActive((prev) => ({ ...prev, [rowId]: false }));
          }
        }
      });
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [productGroupDropdownActive, itRateOnDropdownActive]);
  const [applyDeliveryToday, setApplyDeliveryToday] = useState(true);
  const [finalAmt, setFinalAmt] = useState("0.00");
  const [discType, setDiscType] = useState("%");
  const [discValue, setDiscValue] = useState("0.00");
  const [discAmt, setDiscAmt] = useState("0.00");
  const [gstPercent, setGstPercent] = useState("3");
  const [gstAmt, setGstAmt] = useState("0.00");
  const [roundOff, setRoundOff] = useState("0.00");
  const [total, setTotal] = useState("0.00");
  const [remaining, setRemaining] = useState("0");
  const [note, setNote] = useState("");
  const [returnPeriod, setReturnPeriod] = useState(""); // Return period value
  const [returnPeriodType, setReturnPeriodType] = useState("Month"); // Day or Month
  const [interestPercent, setInterestPercent] = useState(""); // Interest percentage
  const [monthlyInterest, setMonthlyInterest] = useState(""); // Monthly Interest amount
  const [principalGiven, setPrincipalGiven] = useState(""); // Principal Given amount
  const [advancedInterest, setAdvancedInterest] = useState(true);
  const [girviBankId, setGirviBankId] = useState(""); // Girvi Bank ID for AAVAK (gold received)
  const [userProofType, setUserProofType] = useState(""); // Aadhar, PAN, etc.
  const [userProofImg, setUserProofImg] = useState(null);
  const [userProofImgPreview, setUserProofImgPreview] = useState(null);
  const [showUserProofModal, setShowUserProofModal] = useState(false);
  const userProofImgInputRef = useRef(null);
  const [customerSignature, setCustomerSignature] = useState(null);
  const [customerSignaturePreview, setCustomerSignaturePreview] =
    useState(null);
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const customerSignatureInputRef = useRef(null);
  const inputRefs = useRef({});

  // Initialize search text for initial rows
  useEffect(() => {
    tableData.forEach((row) => {
      setProductGroupSearchText((prev) => ({
        ...prev,
        [row.id]: prev[row.id] || "",
      }));
      setItRateOnSearchText((prev) => ({
        ...prev,
        [row.id]: prev[row.id] || DEFAULT_RATE_ON,
      }));
    });
  }, []); // Run only once on mount

  // Calculate Net Weight: NWT = GWT - LWT
  const calculateNetWeight = (grWt, lsWt) => {
    const gross = parseFloat(grWt) || 0;
    const less = parseFloat(lsWt) || 0;
    return Math.max(0, gross - less);
  };

  // Fine weight: FWT = (GWT - LWT) × (Purity ÷ 100)
  const calculateFineWeight = (grWt, lsWt, purity) => {
    const netWt = calculateNetWeight(grWt, lsWt);
    const purityValue = parseFloat(purity) || 0;
    if (netWt <= 0 || purityValue <= 0) return 0;
    return netWt * (purityValue / 100);
  };

  const updateFineWeightCell = (row) => {
    const fWtCell = row?.data?.find((d) => d.id === "fWt");
    if (!fWtCell) return;
    const grWt = row.data.find((d) => d.id === "grWt")?.value || "";
    const lsWt = row.data.find((d) => d.id === "lsWt")?.value || "";
    const purity = row.data.find((d) => d.id === "purity")?.value || "";
    const calculated = calculateFineWeight(grWt, lsWt, purity);
    fWtCell.value = calculated > 0 ? calculated.toFixed(3) : "";
  };

  // Calculate Item Amount based on RateOn
  const calculateItemAmount = (rateOn, rate, grWt, netWt, fWt) => {
    const rateVal = parseFloat(rate) || 0;
    if (rateVal === 0) return 0;

    const rateOnUpper = (rateOn || DEFAULT_RATE_ON).toUpperCase();
    let baseWeight = 0;

    if (rateOnUpper === "NWT") {
      baseWeight = parseFloat(netWt) || 0;
    } else if (rateOnUpper === "GWT") {
      baseWeight = parseFloat(grWt) || 0;
    } else if (rateOnUpper === "FWT") {
      baseWeight = parseFloat(fWt) || 0;
    }

    return baseWeight * rateVal;
  };

  const handleInputChange = (rowIndex, colIndex, value) => {
    setTableData((prevData) => {
      const updatedData = [...prevData];
      const row = updatedData[rowIndex];
      const cell = row.data[colIndex];

      // Update the cell value
      cell.value = value;

      // Mark manual override for itRate
      if (cell.id === "itRate") {
        updatedData[rowIndex].userOverrodeItRate = true;
      }

      // Get all cell values for calculations
      const getValue = (id) => {
        const c = row.data.find((d) => d.id === id);
        return c?.value || "";
      };

      const grWt = getValue("grWt");
      const lsWt = getValue("lsWt");
      const netWt = getValue("netWt");
      const itRateOn = getValue("itRateOn");
      const itRate = getValue("itRate");
      const othAmt = getValue("othAmt");

      // Auto-calculate Net.Wt and F.Wt when Gr.Wt, Ls.Wt or purity changes
      if (cell.id === "grWt" || cell.id === "lsWt" || cell.id === "purity") {
        const calculatedNetWt = calculateNetWeight(grWt, lsWt);
        const netWtCell = row.data.find((d) => d.id === "netWt");
        if (netWtCell) {
          netWtCell.value =
            calculatedNetWt > 0 ? calculatedNetWt.toFixed(3) : "";
        }
        updateFineWeightCell(row);
      }

      // Recalculate itRate and itAmt from live price when relevant fields change
      if (
        cell.id === "itRateOn" ||
        cell.id === "itRate" ||
        cell.id === "grWt" ||
        cell.id === "lsWt" ||
        cell.id === "netWt" ||
        cell.id === "fWt" ||
        cell.id === "purity"
      ) {
        const updated = calculateAndUpdateItRate(updatedData, rowIndex);
        updatedData.splice(0, updatedData.length, ...updated);
      }

      // Reset manual flag if user changes source values
      if (
        cell.id === "grWt" ||
        cell.id === "lsWt" ||
        cell.id === "itRateOn" ||
        cell.id === "itRate" ||
        cell.id === "purity"
      ) {
        const itAmtCell = row.data.find((d) => d.id === "itAmt");
        if (itAmtCell) {
          itAmtCell.isManual = false;
        }
      }

      // Calculate Total Amount (always recalculate unless manually edited)
      const itAmt = parseFloat(getValue("itAmt")) || 0;
      const othAmtVal = parseFloat(othAmt) || 0;
      const totalAmt = itAmt + othAmtVal;

      const totalAmtCell = row.data.find((d) => d.id === "totalAmt");
      if (totalAmtCell && !totalAmtCell.isManual) {
        totalAmtCell.value = totalAmt > 0 ? totalAmt.toFixed(2) : "";
      }

      // Reset totalAmt manual flag if source values change
      if (cell.id === "itAmt" || cell.id === "othAmt") {
        const totalAmtCell = row.data.find((d) => d.id === "totalAmt");
        if (totalAmtCell && cell.id !== "totalAmt") {
          totalAmtCell.isManual = false;
        }
      }

      return updatedData;
    });
  };

  const handleDeleteRow = (rowIndex) => {
    if (tableData.length > 1) {
      setTableData((prevData) => {
        const updatedData = prevData.filter((_, index) => index !== rowIndex);
        // Ensure at least 2 empty rows exist
        const emptyRowsCount = updatedData.filter(
          (row) => !rowHasData(row),
        ).length;
        if (emptyRowsCount < 2) {
          // Add empty rows to maintain at least 2 empty rows
          const rowsToAdd = 2 - emptyRowsCount;
          for (let i = 0; i < rowsToAdd; i++) {
            const newRow = {
              id: updatedData.length + i + 1,
              data: initialRowData.map((cell) => ({
                ...cell,
                displayValue: cell.id === "productGroup" ? "" : undefined,
              })),
            };
            updatedData.push(newRow);
            // Initialize search text for new row
            setProductGroupSearchText((prev) => ({ ...prev, [newRow.id]: "" }));
            setItRateOnSearchText((prev) => ({
              ...prev,
              [newRow.id]: DEFAULT_RATE_ON,
            }));
          }
        }
        return updatedData;
      });
    }
  };

  // Check if row has any data
  const rowHasData = (row) => {
    // Check productGroup - if selected, row has data
    const productGroupCell = row.data.find((c) => c.id === "productGroup");
    if (
      productGroupCell &&
      (productGroupCell.value || productGroupCell.displayValue)
    ) {
      return true;
    }

    // Check if any weight field has value > 0
    const weightFields = ["grWt", "lsWt", "netWt", "fWt"];
    for (const fieldId of weightFields) {
      const cell = row.data.find((c) => c.id === fieldId);
      if (cell && cell.value) {
        const value = parseFloat(cell.value) || 0;
        if (value > 0) return true;
      }
    }

    // Check if rate has value > 0
    const rateCell = row.data.find((c) => c.id === "itRate");
    if (rateCell && rateCell.value) {
      const value = parseFloat(rateCell.value) || 0;
      if (value > 0) return true;
    }

    // Check if any amount field has value > 0
    const amountFields = ["itAmt", "othAmt", "mrp", "totalAmt"];
    for (const fieldId of amountFields) {
      const cell = row.data.find((c) => c.id === fieldId);
      if (cell && cell.value) {
        const value = parseFloat(cell.value) || 0;
        if (value > 0) return true;
      }
    }

    // Check if pcs has value > 0
    const pcsCell = row.data.find((c) => c.id === "pcs");
    if (pcsCell && pcsCell.value) {
      const value = parseFloat(pcsCell.value) || 0;
      if (value > 0) return true;
    }

    return false;
  };

  const handleAddRow = () => {
    const newRow = {
      id: tableData.length + 1,
      data: initialRowData.map((cell) => ({
        ...cell,
        displayValue: cell.id === "productGroup" ? "" : undefined,
      })),
    };
    setTableData((prevData) => {
      const updatedData = [...prevData, newRow];
      // Ensure at least 2 empty rows exist
      const emptyRowsCount = updatedData.filter(
        (row) => !rowHasData(row),
      ).length;
      if (emptyRowsCount < 2) {
        // Add additional empty row if needed
        const additionalRow = {
          id: updatedData.length + 1,
          data: initialRowData.map((cell) => ({
            ...cell,
            displayValue: cell.id === "productGroup" ? "" : undefined,
          })),
        };
        updatedData.push(additionalRow);
        // Initialize search text for additional row
        setProductGroupSearchText((prev) => ({
          ...prev,
          [additionalRow.id]: "",
        }));
        setItRateOnSearchText((prev) => ({
          ...prev,
          [additionalRow.id]: DEFAULT_RATE_ON,
        }));
      }
      return updatedData;
    });
    // Initialize search text for new row
    setProductGroupSearchText((prev) => ({ ...prev, [newRow.id]: "" }));
    setItRateOnSearchText((prev) => ({ ...prev, [newRow.id]: DEFAULT_RATE_ON }));

    // Focus on first input field of new row after a short delay
    setTimeout(() => {
      const firstInput = productGroupInputRefs.current[newRow.id];
      if (firstInput) {
        firstInput.focus();
      }
    }, 100);
  };

  const handlePaymentRowChange = (rowId, field, value) => {
    setPaymentRows((prevRows) =>
      prevRows.map((row) =>
        row.id === rowId ? { ...row, [field]: value } : row,
      ),
    );
  };

  const calculateTotal = () => {
    return tableData.reduce((sum, row) => {
      // Safety check: ensure row and row.data exist
      if (!row || !row.data || !Array.isArray(row.data)) {
        return sum;
      }
      const totalAmt = parseFloat(
        row.data.find((cell) => cell.id === "totalAmt")?.value || 0,
      );
      return sum + (isNaN(totalAmt) ? 0 : totalAmt);
    }, 0);
  };

  // Calculate monthly interest amount
  const calculateInterestAmount = () => {
    // Use manual monthly interest if set, otherwise calculate from principal and percentage
    if (monthlyInterest && parseFloat(monthlyInterest) > 0) {
      return parseFloat(monthlyInterest);
    }
    const principal = parseFloat(principalGiven) || 0;
    const interest = parseFloat(interestPercent) || 0;
    return (principal * interest) / 100;
  };

  // Calculate payment total
  const calculatePaymentTotal = () => {
    return paymentRows.reduce((sum, row) => {
      const amount = parseFloat(row.amount) || 0;
      return sum + (isNaN(amount) ? 0 : amount);
    }, 0);
  };

  // Calculate discount amount
  const calculateDiscountAmount = () => {
    const totalAmount = calculateTotal();
    const discVal = parseFloat(discValue) || 0;
    if (discType === "%") {
      return (totalAmount * discVal) / 100;
    }
    return discVal;
  };

  // Calculate GST amount
  const calculateGstAmount = () => {
    const totalAmount = calculateTotal();
    const discountAmt = calculateDiscountAmount();
    const gstPct = parseFloat(gstPercent) || 0;
    return ((totalAmount - discountAmt) * gstPct) / 100;
  };

  // Calculate round-off (auto)
  const calculateRoundOff = () => {
    const totalAmount = calculateTotal();
    const discountAmt = calculateDiscountAmount();
    const gstAmt = calculateGstAmount();
    const amountBeforeRoundOff = totalAmount - discountAmt + gstAmt;
    const roundedAmount = Math.round(amountBeforeRoundOff);
    return roundedAmount - amountBeforeRoundOff;
  };

  // Calculate grand total
  const calculateGrandTotal = () => {
    const totalAmount = calculateTotal();
    const discountAmt = calculateDiscountAmount();
    const gstAmt = calculateGstAmount();
    const roundOffAmt = calculateRoundOff(); // Always use auto-calculated round off
    return totalAmount - discountAmt + gstAmt - roundOffAmt;
  };

  // Calculate remaining amount
  // remaining_amt should be equal to principal_given initially
  // It will only decrease when customer pays back later (via girvi_payment_entry)
  const calculateRemainingAmount = () => {
    const principalGivenAmount = parseFloat(principalGiven) || 0;
    // Initially, remaining amount = principal given
    // This will be updated in database when customer makes payments later
    return principalGivenAmount;
  };

  // Auto-update Principal Given from payment total when payments change
  useEffect(() => {
    const paymentTotal = calculatePaymentTotal();
    setPrincipalGiven(paymentTotal.toFixed(2));
  }, [paymentRows]);

  // Maintain at least 2 empty rows
  useEffect(() => {
    const emptyRowsCount = tableData.filter((row) => !rowHasData(row)).length;
    if (emptyRowsCount < 2) {
      setTableData((prevData) => {
        const currentEmptyRows = prevData.filter(
          (row) => !rowHasData(row),
        ).length;
        if (currentEmptyRows >= 2) {
          return prevData; // Already has 2 empty rows, no need to add
        }
        const updatedData = [...prevData];
        const rowsToAdd = 2 - currentEmptyRows;
        for (let i = 0; i < rowsToAdd; i++) {
          const newRow = {
            id: prevData.length + i + 1,
            data: initialRowData.map((cell) => ({
              ...cell,
              displayValue: cell.id === "productGroup" ? "" : undefined,
            })),
          };
          updatedData.push(newRow);
          // Initialize search text for new row
          setProductGroupSearchText((prev) => ({ ...prev, [newRow.id]: "" }));
          setItRateOnSearchText((prev) => ({
            ...prev,
            [newRow.id]: DEFAULT_RATE_ON,
          }));
        }
        return updatedData;
      });
    }
  }, [tableData]);

  // Auto-update calculations when values change
  useEffect(() => {
    const totalAmount = calculateTotal();
    setFinalAmt(totalAmount.toFixed(2));

    const discountAmt = calculateDiscountAmount();
    setDiscAmt(discountAmt.toFixed(2));

    const gstAmt = calculateGstAmount();
    setGstAmt(gstAmt.toFixed(2));

    const roundOffAmt = calculateRoundOff();
    setRoundOff(roundOffAmt.toFixed(2));

    const grandTotal = calculateGrandTotal();
    setTotal(grandTotal.toFixed(2));

    const remaining = calculateRemainingAmount();
    setRemaining(remaining.toFixed(2));
  }, [tableData, discType, discValue, gstPercent, principalGiven]);

  useEffect(() => {
    if (!tableData || tableData.length === 0) return;
    setTableData((prev) => {
      let updated = [...prev];
      for (let i = 0; i < updated.length; i++) {
        const pgCell = updated[i].data.find((c) => c.id === "productGroup");
        if (!pgCell || !pgCell.value) continue;
        updated = calculateAndUpdateItRate(updated, i);
      }
      return updated;
    });
  }, [masterGoldRate, masterSilverRate]);

  const ensureGirviBanksLoaded = async () => {
    if (Array.isArray(girviBanks) && girviBanks.length > 0) {
      return girviBanks;
    }
    if (girviBanksLoadPromiseRef.current) {
      return girviBanksLoadPromiseRef.current;
    }
    girviBanksLoadPromiseRef.current = (async () => {
      try {
        const response = await listGirviBanks({});
        const bankRows = normalizeGirviBanksListResponse(response);
        setGirviBanks(bankRows);
        return bankRows;
      } catch (error) {
        console.error("Error fetching girvi banks:", error);
        setGirviBanks([]);
        return [];
      } finally {
        girviBanksLoadPromiseRef.current = null;
      }
    })();
    return girviBanksLoadPromiseRef.current;
  };

  const fetchUserss = async (search = "") => {
    const searchText =
      search !== undefined && search !== null ? String(search).trim() : "";
    if (!searchText || searchText.length < 3) return [];

    try {
      const response = await listCustomerUsers({ search: searchText });
      const party = mapCustomerUsersToPartyList(response);
      if (party?.length) {
        setUserss((prev) => {
          const byId = new Map(
            (Array.isArray(prev) ? prev : []).map((u) => [String(u.id), u]),
          );
          party.forEach((u) => byId.set(String(u.id), u));
          return Array.from(byId.values()).sort((a, b) => b.id - a.id);
        });
        customerSearchCacheRef.current.add(searchText.toLowerCase());
        return party;
      }
      return [];
    } catch (error) {
      console.error("Error fetching users:", error);
      return [];
    }
  };

  // Customer search — only when typing 3+ chars (no pageload list)
  useEffect(() => {
    if (selectedCustomerId) return;

    const nextSearch = [customerMobileSearchText, customerNameSearchText]
      .map((value) => (value ? String(value).trim() : ""))
      .find(
        (value) =>
          value.length >= 3 &&
          !customerSearchCacheRef.current.has(value.toLowerCase()),
      );

    if (!nextSearch) return;
    void fetchUserss(nextSearch);
  }, [
    customerMobileSearchText,
    customerNameSearchText,
    selectedCustomerId,
  ]);

  // Listen for API URL changes — clear form; do not preload master lists
  useEffect(() => {
    const handleApiUrlChange = (event) => {
      console.log(
        "API URL changed in AddGirvi, clearing form...",
        event.detail,
      );

      setProductGroups([]);
      setGirviBanks([]);
      setUserss([]);
      customerSearchCacheRef.current = new Set();
      lastSearchedProductGroupPrefixRef.current = "";
      girviBanksLoadPromiseRef.current = null;
      setTableData([
        {
          id: 1,
          data: initialRowData.map((cell) => ({
            ...cell,
            displayValue: cell.id === "productGroup" ? "" : undefined,
          })),
        },
        {
          id: 2,
          data: initialRowData.map((cell) => ({
            ...cell,
            displayValue: cell.id === "productGroup" ? "" : undefined,
          })),
        },
      ]);
      setCustomerMobile("");
      setCustomerName("");
      setSelectedCustomerId(null);
      setCustomerMobileSearchText("");
      setCustomerNameSearchText("");
      setCustomerMobileDropdownActive(false);
      setCustomerMobileHighlightedIndex(0);
      setCustomerPhoto(null);
      setCustomerPhotoPreview(null);
    };

    window.addEventListener("apiUrlChanged", handleApiUrlChange);

    return () => {
      window.removeEventListener("apiUrlChanged", handleApiUrlChange);
    };
  }, []);

  const handleSave = async () => {
    if (!canCreateGirvi) {
      toast.error("Not authorized to add Dihran");
      return;
    }
    if (!date) {
      toast.error("Please select a date");
      return;
    }

    // Validate items
    const validItems = tableData.filter((row) => {
      const totalAmt = row.data.find((cell) => cell.id === "totalAmt")?.value;
      return totalAmt && parseFloat(totalAmt) > 0;
    });

    if (validItems.length === 0) {
      toast.error("Please add at least one item");
      return;
    }

    try {
      const byUser = JSON.parse(localStorage.getItem("user"))?.id || 1;

      // Prepare items array
      const items = validItems.map((row, idx) => {
        const getValue = (id) => {
          const cell = row.data.find((c) => c.id === id);
          return cell?.value || "";
        };

        const purityValue = parseFloat(getValue("purity") || 0) || 0;
        const gwtVal = parseFloat(getValue("grWt") || 0) || 0;
        const lwtVal = parseFloat(getValue("lsWt") || 0) || 0;
        const fWtVal = parseFloat(getValue("fWt") || 0) || 0;

        // Prefer UI F.Wt; fallback: (GWT - LWT) × (Purity / 100)
        const fineWt =
          fWtVal > 0
            ? fWtVal
            : Number(calculateFineWeight(gwtVal, lwtVal, purityValue).toFixed(4));

        // Form-level Item Image applies to the first item line
        const imageName =
          idx === 0 && itemImage ? itemImage.name : null;

        return {
          product_group_id: parseInt(getValue("productGroup") || 0), // Send ID, not label
          pcs: parseFloat(getValue("pcs") || 0),
          gwt: parseFloat(getValue("grWt") || 0),
          lwt: parseFloat(getValue("lsWt") || 0),
          nwt: parseFloat(getValue("netWt") || 0),
          purity: parseFloat(getValue("purity") || 0) || 0,
          fine_wt: fineWt,
          rate_on: getValue("itRateOn") || DEFAULT_RATE_ON,
          rate: parseFloat(getValue("itRate") || 0),
          other_charges: parseFloat(getValue("othAmt") || 0),
          totalamt: parseFloat(getValue("totalAmt") || 0),
          mrp: parseFloat(getValue("mrp") || 0) || 0,
          remarks: "",
          status: 1,
          image: imageName,
          // Tag No will be auto-generated by API, don't send it
        };
      });

      // Prepare payments array
      const girviPayments = paymentRows
        .filter((row) => row.pay_mode && parseFloat(row.amount || 0) > 0)
        .map((row) => ({
          bank_type: row.type ? parseInt(row.type) : 0,
          pay_mode: PAYMENT_METHOD_LABELS[row.pay_mode] || row.pay_mode,
          remarks: row.remarks || "",
          amt: parseFloat(row.amount || 0),
          aavak_amt: parseFloat(row.amount || 0),
        }));

      const customerMobileValue = (
        customerMobileSearchText ||
        customerMobile ||
        ""
      ).trim();
      const mobileError = getMobileValidationError(customerMobileValue, {
        required: true,
      });
      if (mobileError) {
        toast.error(mobileError);
        return;
      }

      const emailError = getEmailValidationError(customerDetails?.email);
      if (emailError) {
        toast.error(emailError);
        return;
      }

      // New User Handling Logic
      let newUserData = [];
      let userIdToSend = selectedCustomerId;
      let isNewCustomer = false;
      let selectedCustomerData = null;

      if (selectedCustomerId) {
        // Try to find in loaded users
        selectedCustomerData = userss.find((u) => u.id === selectedCustomerId);

        // Check if it's a temporary ID (newly added customer not yet saved to DB)
        if (
          typeof selectedCustomerId === "string" &&
          selectedCustomerId.startsWith("TEMP_")
        ) {
          isNewCustomer = true;
          userIdToSend = null;
        }
      } else if (
        (customerNameSearchText || customerName || "").trim() ||
        (customerMobileSearchText || customerMobile || "").trim()
      ) {
        // No user selected from dropdown, but name/mobile entered -> treat as new user
        isNewCustomer = true;
        userIdToSend = null;

        // Construct temporary customer object from form state
        const typedName = (customerNameSearchText || customerName || "").trim();
        const typedMobile = (
          customerMobileSearchText ||
          customerMobile ||
          ""
        ).trim();
        selectedCustomerData = {
          name: typedName,
          fullName: typedName,
          mobile: typedMobile,
          email: customerDetails.email || "",
          city: customerCity || "",
          address: customerAddress || "",
          aadharNo: customerDetails.aadharNo || "",
          panNo: customerDetails.panNo || "",
          birthDate: customerDetails.birthDate || "",
          maritalStatus: customerDetails.maritalStatus || "",
          anniversaryDate: customerDetails.anniversaryDate || "",
          balance: customerDetails.balance || "",
          saleBalance: customerDetails.saleBalance || "",
          companyName: customerDetails.companyName || "",
          companyAddress: customerDetails.companyAddress || "",
          gstNumber: customerDetails.gstNumber || "",
          reference: customerDetails.reference || "",
          state: customerDetails.state || "",
          area: customerDetails.area || "",
        };
      }

      if (isNewCustomer || customerSaveSuccess) {
        if (selectedCustomerData) {
          newUserData = [
            {
              name: selectedCustomerData.fullName || selectedCustomerData.name,
              mobile: selectedCustomerData.mobile,
              email: selectedCustomerData.email,
              city: selectedCustomerData.city,
              address: selectedCustomerData.address,
              aadhar_no: selectedCustomerData.aadharNo,
              pan_no: selectedCustomerData.panNo,
              birth_date: selectedCustomerData.birthDate || "0000-00-00",
              marital_status: selectedCustomerData.maritalStatus,
              anniversary_date:
                selectedCustomerData.anniversaryDate || "0000-00-00",
              balance: selectedCustomerData.balance,
              sale_balance: selectedCustomerData.saleBalance,
              company_name: selectedCustomerData.companyName,
              company_address: selectedCustomerData.companyAddress,
              GST_number: selectedCustomerData.gstNumber,
              reference: selectedCustomerData.reference,
              state: selectedCustomerData.state,
              area: selectedCustomerData.area || "",
              status: "1",
            },
          ];
        }
      }

      // If Advanced Interest is selected, add an upfront AAVAK payment equal to monthly interest
      if (advancedInterest) {
        const monthlyInt = parseFloat(calculateInterestAmount().toFixed(2));
        // Lazy-load girvi banks only when needed for cash bank id
        const banks = await ensureGirviBanksLoaded();
        let cashBankId = null;
        if (Array.isArray(banks) && banks.length > 0) {
          const cashBank =
            banks.find(
              (b) =>
                String(b.account_type).toLowerCase() === "cash" ||
                String(b.bank_name || "")
                  .toLowerCase()
                  .includes("cash"),
            ) ||
            banks.find((b) =>
              String(b.bank_name || "")
                .toLowerCase()
                .includes("cash"),
            );
          if (cashBank) {
            cashBankId = parseInt(cashBank.id);
          }
        }
        girviPayments.push({
          serial_no: girviPayments.length + 1,
          bank_type: cashBankId ? cashBankId : 0,
          pay_mode: PAYMENT_METHOD_LABELS.cash,
          remarks: "Advanced Interest",
          amt: monthlyInt,
          aavak_amt: monthlyInt,
        });
      }

      const totalAmount = calculateTotal();
      const principalGivenAmount = parseFloat(principalGiven) || 0;

      // Get bank_id from Payment Information (first payment's bank_type)
      let bankIdForAavak = null;
      if (girviPayments.length > 0) {
        const firstPayment = girviPayments[0];
        if (firstPayment.bank_type > 0) {
          bankIdForAavak = String(firstPayment.bank_type);
        }
      }
      // If still no bank selected and advanced interest is enabled, try to use Cash bank id
      if (!bankIdForAavak && advancedInterest) {
        const banks = await ensureGirviBanksLoaded();
        if (Array.isArray(banks) && banks.length > 0) {
          const cashBank =
            banks.find(
              (b) =>
                String(b.account_type).toLowerCase() === "cash" ||
                String(b.bank_name || "")
                  .toLowerCase()
                  .includes("cash"),
            ) ||
            banks.find((b) =>
              String(b.bank_name || "")
                .toLowerCase()
                .includes("cash"),
            );
          if (cashBank) {
            bankIdForAavak = String(cashBank.id);
          }
        }
      }

      // Validate bank selection
      // if (!bankIdForAavak) {
      //   toast.error("Please select a bank in Payment Information Type field");
      //   return;
      // }

      // ----- NEW Modular API create (multipart) -----
      // customer_id must be a number; handle TEMP_ customers by creating customer user.
      let customerIdToSend = selectedCustomerId;
      const isSelectedTemp =
        typeof selectedCustomerId === "string" &&
        selectedCustomerId.startsWith("TEMP_");

      if (isSelectedTemp || customerIdToSend == null || customerIdToSend === "") {
        // Prefer newUserData (created from typed form state).
        const u = newUserData && newUserData.length > 0 ? newUserData[0] : null;
        if (!u) {
          toast.error("Customer is required");
          return;
        }

        const custRes = await createCustomerUser({
          name: u.name,
          mobile: String(u.mobile || "").trim(),
          email: u.email || undefined,
          city: u.city || undefined,
          address: u.address || undefined,
          state: u.state || undefined,
          area: u.area || undefined,
          aadhar_no: u.aadhar_no || undefined,
          pan_no: u.pan_no || undefined,
          birth_date: u.birth_date || undefined,
          marital_status: u.marital_status || undefined,
          anniversary_date: u.anniversary_date || undefined,
          company_name: u.company_name || undefined,
          company_address: u.company_address || undefined,
          gst_number: u.GST_number || undefined,
          reference: u.reference || undefined,
          balance: Number(u.balance) || 0,
        });

        if (!custRes?.success) {
          toast.error(custRes?.message || "Failed to create customer");
          return;
        }

        customerIdToSend =
          custRes.data?.id ??
          custRes.data?.customer_id ??
          custRes.customer_id ??
          custRes.id;
      }

      const numericCustomerId = Number(customerIdToSend);
      if (Number.isNaN(numericCustomerId) || numericCustomerId <= 0) {
        toast.error("Invalid customer id");
        return;
      }

      // For new contract, item list is required.
      if (!Array.isArray(items) || items.length === 0) {
        toast.error("No valid items to submit");
        return;
      }

      const basePayloadForIdempotency = {
        type: "create",
        customer_id: numericCustomerId,
        girvi_date: date,
        principal_given: principalGivenAmount,
        interest_percent: parseFloat(interestPercent) || 0,
        return_period: parseInt(returnPeriod) || 0,
        return_period_type: returnPeriodType || "Month",
        girvi_bank_id: bankIdForAavak ? Number(bankIdForAavak) : null,
        items: items.map((it) => ({
          product_group_id: it.product_group_id,
          tag_no: it.tag_no ?? null,
          pcs: it.pcs,
          gwt: it.gwt,
          lwt: it.lwt,
          nwt: it.nwt,
          fine_wt: it.fine_wt,
          purity: it.purity,
          rate_on: it.rate_on,
          rate: it.rate,
          other_charges: it.other_charges,
          totalamt: it.totalamt,
          mrp: it.mrp,
          remarks: it.remarks,
          status: it.status,
          image: it.image,
        })),
      };

      const fingerprint = JSON.stringify(basePayloadForIdempotency);
      if (
        !girviCreateIdempotencyKeyRef.current ||
        girviCreatePayloadFingerprintRef.current !== fingerprint
      ) {
        girviCreateIdempotencyKeyRef.current = createGirviIdempotencyKey();
        girviCreatePayloadFingerprintRef.current = fingerprint;
      }

      const formDataForApi = new FormData();
      formDataForApi.append("type", "create");
      formDataForApi.append(
        "idempotency_key",
        girviCreateIdempotencyKeyRef.current,
      );
      formDataForApi.append("customer_id", String(numericCustomerId));
      formDataForApi.append("girvi_date", date);
      formDataForApi.append("principal_given", String(principalGivenAmount));
      formDataForApi.append(
        "interest_percent",
        String(parseFloat(interestPercent) || 0),
      );
      formDataForApi.append(
        "return_period",
        String(parseInt(returnPeriod) || 0),
      );
      formDataForApi.append(
        "return_period_type",
        returnPeriodType || "Month",
      );
      if (bankIdForAavak) {
        formDataForApi.append("girvi_bank_id", String(bankIdForAavak));
      }
      // Backend parses JSON string when items are sent in multipart.
      formDataForApi.append("items", JSON.stringify(items));

      if (userProofType) {
        formDataForApi.append("user_proof_type", userProofType);
      }
      if (userProofImg) {
        formDataForApi.append(
          "user_proof_img",
          userProofImg,
          userProofImg.name || "user_proof_img",
        );
      }
      if (customerSignature) {
        formDataForApi.append(
          "customer_signature",
          customerSignature,
          customerSignature.name || "customer_signature",
        );
      }
      if (customerPhoto) {
        formDataForApi.append(
          "customer_photo",
          customerPhoto,
          customerPhoto.name || "customer_photo",
        );
      }

      if (itemImage) {
        formDataForApi.append(
          "image_0",
          itemImage,
          itemImage.name || "item_image",
        );
      }

      if (note && note.trim()) {
        formDataForApi.append("remarks", note.trim());
      }

      const response = await createGirviMultipart(formDataForApi);
      const girvi_document_id =
        response?.data?.girvi_document_id ?? response?.girvi_document_id;

      if (girvi_document_id) {
        toast.success("Girvi transaction saved successfully!");
        try {
          await showGirvi({ id: girvi_document_id });
        } catch {
          // ignore refresh failure; navigation still works
        }
        girviCreateIdempotencyKeyRef.current = null;
        girviCreatePayloadFingerprintRef.current = null;
        navigate("/girvitable");
      } else {
        toast.error(
          response?.message || "Failed to save Girvi transaction",
        );
      }
    } catch (error) {
      console.error("Error saving Girvi transaction:", error);
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Failed to save Girvi transaction",
      );
    }
  };

  // Customer selection handlers
  const handleCustomerMobileChange = (e) => {
    const value = sanitizeMobileInput(e.target.value);
    setCustomerMobileSearchText(value);
    setCustomerMobile(value);
    setCustomerMobileDropdownActive(true);
    setCustomerMobileHighlightedIndex(0);
    setSelectedCustomerId(null);
  };

  const getFilteredUserssByMobile = (searchText) => {
    if (!searchText) return userss;
    const searchLower = searchText.toLowerCase();
    return userss.filter((item) =>
      item.mobile.toLowerCase().includes(searchLower),
    );
  };

  const handleCustomerMobileSelect = (selectedItem) => {
    setCustomerMobile(selectedItem.mobile);
    setCustomerMobileSearchText(selectedItem.mobile);
    setCustomerMobileDropdownActive(false);
    setSelectedCustomerId(selectedItem.id);
    setCustomerName(selectedItem.fullName);
    setCustomerNameSearchText(selectedItem.fullName);
  };

  const handleCustomerMobileKeyDown = (e) => {
    const filtered = getFilteredUserssByMobile(customerMobileSearchText);

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setCustomerMobileHighlightedIndex((prevIndex) => {
          const newIndex =
            prevIndex < filtered.length - 1 ? prevIndex + 1 : prevIndex;
          if (customerMobileItemsRef.current[newIndex]) {
            customerMobileItemsRef.current[newIndex].scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
          }
          return newIndex;
        });
        break;
      case "ArrowUp":
        e.preventDefault();
        setCustomerMobileHighlightedIndex((prevIndex) => {
          const newIndex = prevIndex > 0 ? prevIndex - 1 : 0;
          if (customerMobileItemsRef.current[newIndex]) {
            customerMobileItemsRef.current[newIndex].scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
          }
          return newIndex;
        });
        break;
      case "Enter":
        e.preventDefault();
        if (filtered.length > 0 && customerMobileDropdownActive) {
          handleCustomerMobileSelect(filtered[customerMobileHighlightedIndex]);
        }
        break;
      case "Escape":
        e.preventDefault();
        setCustomerMobileDropdownActive(false);
        break;
      case "Tab":
        setCustomerMobileDropdownActive(false);
        break;
      default:
        break;
    }
  };

  // Handle click outside dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        customerMobileDropdownRef.current &&
        !customerMobileDropdownRef.current.contains(event.target) &&
        customerMobileInputRef.current &&
        !customerMobileInputRef.current.contains(event.target)
      ) {
        setCustomerMobileDropdownActive(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const renderCustomerMobileDropdown = () => {
    if (!customerMobileDropdownActive) return null;

    const filtered = getFilteredUserssByMobile(customerMobileSearchText);
    customerMobileItemsRef.current = [];

    const inputWidth = customerMobileInputRef.current
      ? customerMobileInputRef.current.offsetWidth
      : 150;
    const inputRect = customerMobileInputRef.current
      ? customerMobileInputRef.current.getBoundingClientRect()
      : null;

    if (!inputRect) return null;

    return ReactDOM.createPortal(
      <div
        ref={customerMobileDropdownRef}
        className="dropdown-menu show shadow-sm girvi-customer-dropdown"
        style={{
          position: "fixed",
          top: `${inputRect.bottom}px`,
          left: `${inputRect.left}px`,
          width: `${inputWidth}px`,
          minWidth: `${inputWidth}px`,
          maxWidth: `${inputWidth}px`,
          maxHeight: "150px",
          overflowY: "auto",
          zIndex: 9999,
          border: "none",
          borderRadius: "0.5rem",
          padding: "0.5rem 0",
          backgroundColor: "#fff",
          fontSize: "12px",
          lineHeight: "1.2",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        }}
      >
        {filtered.length > 0 ? (
          filtered.map((item, idx) => {
            const isSelected =
              item.mobile.toLowerCase() ===
              customerMobileSearchText.toLowerCase();

            return (
              <div
                key={idx}
                ref={(el) => (customerMobileItemsRef.current[idx] = el)}
                className="dropdown-item"
                style={{
                  cursor: "pointer",
                  padding: "0.25rem 1rem",
                  fontSize: "0.85rem",
                  backgroundColor:
                    idx === customerMobileHighlightedIndex
                      ? "var(--theme-primary)"
                      : isSelected
                        ? GIRVI_THEME.bgLight
                        : "transparent",
                  color:
                    idx === customerMobileHighlightedIndex
                      ? GIRVI_THEME.textColor
                      : "inherit",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  transition: "background-color 0.2s, color 0.2s",
                }}
                onMouseEnter={() => setCustomerMobileHighlightedIndex(idx)}
                onMouseDown={() => handleCustomerMobileSelect(item)}
              >
                {item.mobile} - {item.name}
              </div>
            );
          })
        ) : (
          <div className="dropdown-item disabled">No matching users</div>
        )}
      </div>,
      document.getElementById("dropdown-portal") || document.body,
    );
  };

  return (
    <>
      <style>
        {`
          .girvi-customer-dropdown .dropdown-item:hover,
          .girvi-customer-dropdown .dropdown-item.active {
            background-color: ${GIRVI_THEME.bgColor} !important;
            color: #fff !important;
          }
        `}
      </style>
      <div className="body-wrapper">
        <div className="container-fluid">
          <div
            className={`card w-100 position-relative overflow-hidden ${cardClass} ${buttonTableStyle === "square" ? "rounded-0" : ""
              }`}
          >
            <div className="px-4 py-3 border-bottom d-flex justify-content-between align-items-center">
              <h4 className="card-title mb-0">Add Dihran</h4>
              <div className="d-flex align-items-center">
                <label className="mb-0 me-2 small fw-semibold text-muted">
                  Date:
                </label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  style={{
                    width: "160px",
                    borderRadius: "8px",
                    borderColor: GIRVI_THEME.borderColor,
                  }}
                />
              </div>
            </div>
            <div className="card-body p-4">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                {/* <h4 className="text-black mb-1 fw-bold">Add Dihran</h4>
                <div className="d-flex align-items-center">
                  <label className="mb-0 me-2 small fw-semibold text-muted">
                    Date:
                  </label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    style={{
                      width: "160px",
                      backgroundColor: "transparent",
                      borderColor: GIRVI_THEME.borderColor,
                    }}
                  />
                </div> */}
              </div>
              {/* <hr
                className="my-4"
                style={{ borderTop: "1px solid #dcdcdc", opacity: 1 }}
              /> */}
              <CustomerSelection
                customerMobile={customerMobile}
                setCustomerMobile={setCustomerMobile}
                customerMobileSearchText={customerMobileSearchText}
                setCustomerMobileSearchText={setCustomerMobileSearchText}
                customerName={customerName}
                setCustomerName={setCustomerName}
                customerNameSearchText={customerNameSearchText}
                setCustomerNameSearchText={setCustomerNameSearchText}
                customerAddress={customerAddress}
                setCustomerAddress={setCustomerAddress}
                customerDetails={customerDetails}
                setCustomerDetails={setCustomerDetails}
                customerCity={customerCity}
                setCustomerCity={setCustomerCity}
                selectedCustomerId={selectedCustomerId}
                setSelectedCustomerId={setSelectedCustomerId}
                customerSaveSuccess={customerSaveSuccess}
                setCustomerSaveSuccess={setCustomerSaveSuccess}
                users={userss}
                setUsers={setUserss}
                states={states}
                cities={cities}
                selectedState={selectedState}
                setSelectedState={setSelectedState}
                buttonClass={buttonClass}
              />
              <hr
                className="my-4"
                style={{ borderTop: "1px solid #dcdcdc", opacity: 1 }}
              />
              <div className="row">
                <div className="col-12 col-xl-9">
                  <h6
                    className="fw-bold mb-3 d-flex align-items-center"
                    style={{ color: GIRVI_THEME.bgColor }}
                  >
                    Dihran Details
                  </h6>
                  <div className="col-12 mb-2">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label small fw-semibold text-muted mb-1">
                          Item Value (Total)
                        </label>
                        <input
                          type="text"
                          className="form-control bg-light"
                          readOnly
                          value={calculateTotal().toFixed(2)}
                          style={{
                            borderRadius: "8px",
                            fontWeight: "600",
                            borderColor: GIRVI_THEME.borderColor,
                          }}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label small fw-semibold text-muted mb-1">
                          Principal Given 
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          value={principalGiven}
                          onChange={(e) => {
                            setPrincipalGiven(e.target.value);
                            if (interestPercent) {
                              const principal = parseFloat(e.target.value) || 0;
                              const interest = parseFloat(interestPercent) || 0;
                              setMonthlyInterest(
                                ((principal * interest) / 100).toFixed(2),
                              );
                            }
                          }}
                          placeholder="Enter amount"
                          step="0.01"
                          style={{
                            borderRadius: "8px",
                            borderColor: GIRVI_THEME.borderColor,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-2">
                    <div className="row g-3 align-items-end">
                      <div className="col-md-4">
                        <label className="small fw-semibold text-muted mb-2 d-block">
                          Item Image
                        </label>
                        <div className="d-flex gap-2 align-items-center">
                          <input
                            ref={itemImageInputRef}
                            type="file"
                            className="form-control"
                            accept="image/*"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                setItemImage(file);
                                const reader = new FileReader();
                                reader.onloadend = () => {
                                  setItemImagePreview(reader.result);
                                };
                                reader.readAsDataURL(file);
                              } else {
                                setItemImage(null);
                                setItemImagePreview(null);
                              }
                            }}
                            style={{
                              borderRadius: "8px",
                              borderColor: GIRVI_THEME.borderColor,
                              padding: "0.375rem 0.75rem",
                              height: "38px",
                              lineHeight: "1.5",
                              fontSize: "0.9rem",
                              width: "100%",
                            }}
                          />
                          {itemImagePreview && (
                            <button
                              type="button"
                              className="btn d-flex align-items-center justify-content-center flex-shrink-0"
                              onClick={() => setShowItemImageModal(true)}
                              style={{
                                backgroundColor: GIRVI_THEME.bgColor,
                                color: GIRVI_THEME.textColor,
                                borderRadius: "8px",
                                minWidth: "45px",
                                width: "45px",
                                height: "38px",
                                padding: "0",
                                border: "none",
                              }}
                            >
                              <iconify-icon
                                icon="solar:eye-bold-duotone"
                                width="18"
                                height="18"
                                style={{ color: "#ffffff" }}
                              />
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <label className="small fw-semibold text-muted mb-2 d-block">
                          Return Period
                        </label>
                        <div className="d-flex gap-2">
                          <select
                            className="form-select"
                            value={returnPeriodType}
                            onChange={(e) =>
                              setReturnPeriodType(e.target.value)
                            }
                            style={{
                              borderRadius: "8px",
                              borderColor: GIRVI_THEME.borderColor,
                              width: "40%",
                              minWidth: "120px",
                            }}
                          >
                            <option value="Day">Day</option>
                            <option value="Month">Month</option>
                          </select>
                          <input
                            type="number"
                            className="form-control"
                            placeholder={
                              returnPeriodType === "Day"
                                ? "Enter days"
                                : "Enter months"
                            }
                            value={returnPeriod}
                            onChange={(e) => setReturnPeriod(e.target.value)}
                            min="1"
                            style={{
                              borderRadius: "8px",
                              borderColor: GIRVI_THEME.borderColor,
                              flex: 1,
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <label className="small fw-semibold text-muted mb-2 d-block">
                          Interest(%)
                        </label>
                        <div className="d-flex gap-3 align-items-center">
                          <input
                            id="interestPercentInput"
                            type="number"
                            className="form-control"
                            placeholder="Enter rate"
                            value={interestPercent}
                            onChange={(e) => {
                              setInterestPercent(e.target.value);
                              if (principalGiven) {
                                const principal =
                                  parseFloat(principalGiven) || 0;
                                const interest =
                                  parseFloat(e.target.value) || 0;
                                setMonthlyInterest(
                                  ((principal * interest) / 100).toFixed(2),
                                );
                              }
                            }}
                            min="0"
                            step="0.01"
                            style={{
                              borderRadius: "8px",
                              borderColor: GIRVI_THEME.borderColor,
                              flex: 1,
                              minWidth: "120px",
                            }}
                          />
                          <div className="form-check mb-0 flex-shrink-0">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="advancedInterestCheck"
                              checked={advancedInterest}
                              onChange={(e) =>
                                setAdvancedInterest(e.target.checked)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="advancedInterestCheck"
                            >
                              Advanced Interest
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-2">
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label className="form-label small fw-semibold text-muted mb-1">
                          User Proof Type
                        </label>
                        <select
                          className="form-select"
                          value={userProofType}
                          onChange={(e) => setUserProofType(e.target.value)}
                          style={{
                            borderRadius: "8px",
                            borderColor: GIRVI_THEME.borderColor,
                          }}
                        >
                          <option value="">Select Proof Type</option>
                          <option value="Aadhar">Aadhar Card</option>
                          <option value="PAN">PAN Card</option>
                          <option value="Driving License">
                            Driving License
                          </option>
                          <option value="Voter ID">Voter ID</option>
                          <option value="Passport">Passport</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label small fw-semibold text-muted mb-1">
                          User Proof Image
                        </label>
                        <div className="d-flex gap-2 align-items-center">
                          <input
                            ref={userProofImgInputRef}
                            type="file"
                            className="form-control"
                            accept="image/*"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                setUserProofImg(file);
                                const reader = new FileReader();
                                reader.onloadend = () => {
                                  setUserProofImgPreview(reader.result);
                                };
                                reader.readAsDataURL(file);
                              }
                            }}
                            style={{
                              borderRadius: "8px",
                              borderColor: GIRVI_THEME.borderColor,
                              padding: "0.375rem 0.75rem",
                              height: "38px",
                              lineHeight: "1.5",
                              fontSize: "0.9rem",
                            }}
                          />
                          {userProofImgPreview && (
                            <button
                              type="button"
                              className="btn d-flex align-items-center justify-content-center"
                              onClick={() => setShowUserProofModal(true)}
                              style={{
                                backgroundColor: GIRVI_THEME.bgColor,
                                color: GIRVI_THEME.textColor,
                                borderRadius: "8px",
                                minWidth: "45px",
                                width: "45px",
                                height: "38px",
                                padding: "0",
                                border: "none",
                              }}
                            >
                              <iconify-icon
                                icon="solar:eye-bold-duotone"
                                width="18"
                                height="18"
                                style={{ color: "#ffffff" }}
                              />
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label small fw-semibold text-muted mb-1">
                          Customer Signature
                        </label>
                        <div className="d-flex gap-2 align-items-center">
                          <input
                            ref={customerSignatureInputRef}
                            type="file"
                            className="form-control"
                            accept="image/*"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                setCustomerSignature(file);
                                const reader = new FileReader();
                                reader.onloadend = () => {
                                  setCustomerSignaturePreview(reader.result);
                                };
                                reader.readAsDataURL(file);
                              }
                            }}
                            style={{
                              borderRadius: "8px",
                              borderColor: GIRVI_THEME.borderColor,
                              padding: "0.375rem 0.75rem",
                              height: "38px",
                              lineHeight: "1.5",
                              fontSize: "0.9rem",
                            }}
                          />
                          {customerSignaturePreview && (
                            <button
                              type="button"
                              className="btn d-flex align-items-center justify-content-center"
                              onClick={() => setShowSignatureModal(true)}
                              style={{
                                backgroundColor: GIRVI_THEME.bgColor,
                                color: GIRVI_THEME.textColor,
                                borderRadius: "8px",
                                minWidth: "45px",
                                width: "45px",
                                height: "38px",
                                padding: "0",
                                border: "none",
                              }}
                            >
                              <iconify-icon
                                icon="solar:eye-bold-duotone"
                                width="18"
                                height="18"
                                style={{ color: "#ffffff" }}
                              />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <label className="form-label small fw-semibold text-muted mb-1">
                      Remarks
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      placeholder="Enter remarks..."
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                      maxLength={200}
                      style={{
                        borderRadius: "8px",
                        borderColor: GIRVI_THEME.borderColor,
                        fontSize: "0.9rem",
                      }}
                    />
                  </div>
                  <div className="mt-3">
                    <div className="d-flex flex-wrap align-items-center">
                      <div className="form-check me-3 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="printCheckbox"
                        />
                        <label
                          className="form-check-label d-flex align-items-center"
                          htmlFor="printCheckbox"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi"
                            viewBox="0 0 24 24"
                          >
                            <g
                              fill="none"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                            >
                              <path d="M17 17h2a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2m10-8V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v4" />
                              <path d="M7 15a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2z" />
                            </g>
                          </svg>
                          <span className="ms-2 d-none d-sm-inline">Print</span>
                        </label>
                      </div>
                      <div className="form-check me-3 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="pdfCheckbox"
                        />
                        <label
                          className="form-check-label d-flex align-items-center"
                          htmlFor="pdfCheckbox"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi"
                            viewBox="0 0 24 24"
                          >
                            <g
                              fill="none"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                            >
                              <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                              <path d="M5 12V5a2 2 0 0 1 2-2h7l5 5v4M5 18h1.5a1.5 1.5 0 0 0 0-3H5v6m12-3h2m1-3h-3v6m-6-6v6h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2z" />
                            </g>
                          </svg>
                          <span className="ms-2 d-none d-sm-inline">PDF</span>
                        </label>
                      </div>
                      <div className="form-check me-3 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="whatsappCheckbox"
                        />
                        <label
                          className="form-check-label d-flex align-items-center"
                          htmlFor="whatsappCheckbox"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi"
                            viewBox="0 0 24 24"
                          >
                            <g
                              fill="none"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                            >
                              <path d="m3 21l1.65-3.8a9 9 0 1 1 3.4 2.9z" />
                              <path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0za5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1" />
                            </g>
                          </svg>
                          <span className="ms-2 d-none d-sm-inline">
                            WhatsApp
                          </span>
                        </label>
                      </div>
                      <div className="form-check me-3 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="emailCheckbox"
                        />
                        <label
                          className="form-check-label d-flex align-items-center"
                          htmlFor="emailCheckbox"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi"
                            viewBox="0 0 24 24"
                          >
                            <g
                              fill="none"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                            >
                              <path d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                              <path d="m3 7l9 6l9-6" />
                            </g>
                          </svg>
                          <span className="ms-2 d-none d-sm-inline">Email</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Side - Summary Panel */}
                <div className="col-12 col-xl-3 border-start">
                  {/* Product Details */}
                  <div className="mb-4">
                    <h6
                      className="mb-3 fw-bold d-flex align-items-center"
                      style={{ color: GIRVI_THEME.bgColor }}
                    >
                      Item Details
                    </h6>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div>
                        <div className="small text-muted">Items Added</div>
                        <div
                          className="fw-semibold"
                          style={{ color: GIRVI_THEME.bgColor }}
                        >
                          {
                            tableData.filter((row) => {
                              const totalAmt = row.data.find(
                                (c) => c.id === "totalAmt",
                              )?.value;
                              return totalAmt && parseFloat(totalAmt) > 0;
                            }).length
                          }
                        </div>
                      </div>
                      <div>
                        <div className="small text-muted">Total Amount</div>
                        <div
                          className="fw-semibold"
                          style={{ color: GIRVI_THEME.bgColor }}
                        >
                          ₹ {calculateTotal().toFixed(2)}
                        </div>
                      </div>
                    </div>
                    <button
                      className={`btn btn-primary w-100 ${buttonClass}`}
                      onClick={() => setShowItemsModal(true)}
                      style={{
                        backgroundColor: GIRVI_THEME.bgColor,
                        borderColor: GIRVI_THEME.bgColor,
                        color: GIRVI_THEME.textColor,
                        borderRadius: "8px",
                        padding: "8px 12px",
                        fontWeight: 600,
                      }}
                    >
                      Add Item
                    </button>
                  </div>

                  <hr
                    className="my-4"
                    style={{ borderTop: "1px solid #dcdcdc", opacity: 1 }}
                  />

                  {/* Financial Summary */}
                  <div>
                    <h6
                      className="mb-3 fw-bold d-flex align-items-center"
                      style={{ color: GIRVI_THEME.bgColor }}
                    >
                      Financial Summary
                    </h6>
                    <div className="mb-2">
                      <p
                        className="mb-1"
                        style={{
                          fontSize: "0.9rem",
                          color: "#495057",
                          fontWeight: "500",
                        }}
                      >
                        1. Principal Given: ₹{principalGiven || ""}
                      </p>
                    </div>

                    <div className="mb-2">
                      <p
                        className="mb-1"
                        style={{
                          fontSize: "0.9rem",
                          color: "#495057",
                          fontWeight: "500",
                        }}
                      >
                        2. Interest Taken: {interestPercent || "0"}%
                      </p>
                    </div>

                    <div className="mb-3">
                      <p
                        className="mb-1"
                        style={{
                          fontSize: "0.9rem",
                          color: "#495057",
                          fontWeight: "500",
                        }}
                      >
                        3. Monthly Interest: ₹
                        {calculateInterestAmount().toFixed(2)}
                      </p>
                    </div>

                    <div className="mb-3">
                      <label
                        className="form-label small fw-semibold mb-1"
                        style={{ color: "var(--theme-primary)" }}
                      >
                        Remaining Amount
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="0"
                        value={remaining}
                        readOnly
                        style={{
                          borderRadius: "8px",
                          borderColor: GIRVI_THEME.borderColor,
                        }}
                      />
                    </div>
                    {/* Save Button */}
                    <button
                      className={`btn d-flex align-items-center justify-content-center w-100 ${buttonClass}`}
                      onClick={handleSave}
                      style={{
                        backgroundColor: GIRVI_THEME.bgColor,
                        color: GIRVI_THEME.textColor,
                        borderColor: GIRVI_THEME.bgColor,
                        borderRadius: "8px",
                        padding: "8px 10px",
                        fontSize: "1rem",
                        fontWeight: "600",
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showItemsModal}
        onHide={() => setShowItemsModal(false)}
        centered
        dialogClassName="girvi-items-modal-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>Item Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          <div className="table-responsive">
            <table
              className={`table table-bordered table-hover table-sm mb-0 ${tableClass} theme-header-table`}
            >
              <thead>
                <tr>
                  {COLUMNS.map((column) => (
                    <th
                      key={column.id}
                      className={`px-2 py-2 ${column.id === "productGroup"
                        ? "text-start"
                        : "text-center"
                        }`}
                      style={{
                        fontSize: "0.8rem",
                        width: column.width,
                        fontWeight: "600",
                        whiteSpace: "nowrap",
                        borderColor: GIRVI_THEME.borderColor,
                      }}
                    >
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, rowIndex) => (
                  <tr key={row.id}>
                    {row.data.map((cell, colIndex) => {
                      if (cell.id === "no") {
                        return (
                          <td
                            key={cell.id}
                            className="p-0 text-center"
                            style={{ width: COLUMNS[colIndex]?.width }}
                          >
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{ height: "38px" }}
                            >
                              <span
                                style={{
                                  fontSize: "0.85rem",
                                  cursor: "pointer",
                                  fontWeight: "600",
                                  color: "var(--theme-primary)",
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  transition: "all 0.2s",
                                }}
                                onClick={() => handleDeleteRow(rowIndex)}
                                onMouseEnter={(e) => {
                                  e.target.textContent = "×";
                                  e.target.style.backgroundColor =
                                    "#dc3545";
                                  e.target.style.color = "#fff";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.textContent = rowIndex + 1;
                                  e.target.style.backgroundColor =
                                    "transparent";
                                  e.target.style.color = "var(--theme-primary)";
                                }}
                              >
                                {rowIndex + 1}
                              </span>
                            </div>
                          </td>
                        );
                      }
                      if (cell.id === "productGroup") {
                        const rowId = row.id;
                        const selectedGroup = productGroups?.find(
                          (g) => g.value === cell.value,
                        );
                        const searchText = productGroupSearchText[rowId];
                        const showValue =
                          searchText !== undefined
                            ? searchText
                            : selectedGroup
                              ? selectedGroup.label
                              : cell.displayValue || "";
                        return (
                          <td
                            key={cell.id}
                            className="p-0 position-relative"
                            style={{ width: COLUMNS[colIndex]?.width }}
                          >
                            <input
                              ref={(el) =>
                              (productGroupInputRefs.current[rowId] =
                                el)
                              }
                              type="text"
                              className="form-control border-0 rounded-0"
                              style={{
                                fontSize: "0.8rem",
                                padding: "0.4rem 0.5rem",
                                backgroundColor: "transparent",
                                width: "80%",
                              }}
                              value={showValue}
                              onChange={(e) =>
                                handleProductGroupChange(
                                  rowId,
                                  e.target.value,
                                )
                              }
                              onKeyDown={(e) =>
                                handleProductGroupKeyDown(e, rowId)
                              }
                              onClick={() =>
                                setProductGroupDropdownActive((prev) => ({
                                  ...prev,
                                  [rowId]: true,
                                }))
                              }
                              onFocus={(e) => {
                                e.target.style.backgroundColor = "#fff";
                                e.target.style.boxShadow =
                                  "inset 0 0 0 2px rgba(255, 102, 146, 0.3)";
                                setProductGroupDropdownActive((prev) => ({
                                  ...prev,
                                  [rowId]: true,
                                }));
                              }}
                              onBlur={(e) => {
                                e.target.style.backgroundColor =
                                  "transparent";
                                e.target.style.boxShadow = "none";
                                setTimeout(() => {
                                  setProductGroupDropdownActive(
                                    (prev) => ({
                                      ...prev,
                                      [rowId]: false,
                                    }),
                                  );
                                }, 200);
                              }}
                              autoComplete="off"
                              placeholder="Select Product Group"
                            />
                            {renderProductGroupDropdown(rowId)}
                          </td>
                        );
                      }
                      if (cell.id === "itRateOn") {
                        const rowId = row.id;
                        const displayValue =
                          cell.value ||
                          itRateOnSearchText[rowId] ||
                          DEFAULT_RATE_ON;
                        return (
                          <td
                            key={cell.id}
                            className="p-0 position-relative"
                            style={{ width: COLUMNS[colIndex]?.width }}
                          >
                            <input
                              ref={(el) =>
                                (itRateOnInputRefs.current[rowId] = el)
                              }
                              type="text"
                              className="form-control border-0 rounded-0"
                              style={{
                                fontSize: "0.8rem",
                                padding: "0.4rem 0.5rem",
                                backgroundColor: "transparent",
                                width: "100%",
                                border: "none",
                                outline: "none",
                              }}
                              value={displayValue}
                              onChange={(e) =>
                                handleItRateOnChange(
                                  rowId,
                                  e.target.value,
                                )
                              }
                              onKeyDown={(e) =>
                                handleItRateOnKeyDown(e, rowId)
                              }
                              onClick={() =>
                                setItRateOnDropdownActive((prev) => ({
                                  ...prev,
                                  [rowId]: true,
                                }))
                              }
                              onFocus={(e) => {
                                e.target.style.backgroundColor = "#fff";
                                e.target.style.boxShadow = "none";
                                setItRateOnDropdownActive((prev) => ({
                                  ...prev,
                                  [rowId]: true,
                                }));
                              }}
                              onBlur={(e) => {
                                e.target.style.backgroundColor =
                                  "transparent";
                                e.target.style.boxShadow = "none";
                                setTimeout(() => {
                                  setItRateOnDropdownActive((prev) => ({
                                    ...prev,
                                    [rowId]: false,
                                  }));
                                }, 200);
                              }}
                              autoComplete="off"
                            />
                            {renderItRateOnDropdown(rowId)}
                          </td>
                        );
                      }
                      return (
                        <td
                          key={cell.id}
                          className="p-0"
                          style={{
                            width: COLUMNS[colIndex]?.width,
                            position: "relative",
                          }}
                        >
                          <input
                            ref={(el) =>
                            (inputRefs.current[
                              `${rowIndex}-${colIndex}`
                            ] = el)
                            }
                            type={
                              [
                                "pcs",
                                "grWt",
                                "lsWt",
                                "netWt",
                                "fWt",
                                "itRate",
                                "itAmt",
                                "othAmt",
                                "mrp",
                                "totalAmt",
                              ].includes(cell.id)
                                ? "number"
                                : "text"
                            }
                            placeholder={[
                              "pcs",
                              "grWt",
                              "lsWt",
                              "netWt",
                              "fWt",
                              "itRate",
                              "itAmt",
                              "othAmt",
                              "mrp",
                              "totalAmt",
                            ].includes(cell.id)}
                            value={cell.value}
                            onChange={(e) => {
                              if (
                                cell.id === "itAmt" ||
                                cell.id === "totalAmt"
                              ) {
                                cell.isManual = true;
                              }
                              handleInputChange(
                                rowIndex,
                                colIndex,
                                e.target.value,
                              );
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.key === "Enter" &&
                                cell.id === "totalAmt"
                              ) {
                                e.preventDefault();
                                const currentRow = tableData[rowIndex];
                                if (rowHasData(currentRow)) {
                                  handleAddRow();
                                }
                              }
                            }}
                            className={`form-control border-0 rounded-0 ${(cell.id === "netWt" ||
                              cell.id === "fWt" ||
                              cell.id === "itAmt" ||
                              cell.id === "totalAmt") &&
                              !cell.isManual
                              ? "bg-light"
                              : ""
                              }`}
                            style={{
                              fontSize: "0.8rem",
                              padding: "0.4rem 0.5rem",
                              backgroundColor:
                                (cell.id === "netWt" ||
                                  cell.id === "fWt" ||
                                  cell.id === "itAmt" ||
                                  cell.id === "totalAmt") &&
                                  !cell.isManual
                                  ? "#f8f9fa"
                                  : "transparent",
                              width: "100%",
                            }}
                            onFocus={(e) => {
                              e.target.style.backgroundColor = "#fff";
                              e.target.style.boxShadow =
                                "inset 0 0 0 2px rgba(139, 69, 19, 0.3)";
                            }}
                            onBlur={(e) => {
                              const bgColor =
                                (cell.id === "netWt" ||
                                  cell.id === "fWt" ||
                                  cell.id === "itAmt" ||
                                  cell.id === "totalAmt") &&
                                  !cell.isManual
                                  ? "#f8f9fa"
                                  : "transparent";
                              e.target.style.backgroundColor = bgColor;
                              e.target.style.boxShadow = "none";
                            }}
                            autoComplete="off"
                          />
                        </td>
                      );
                    })}
                  </tr>
                ))}
                <tr
                  style={{
                    backgroundColor: GIRVI_THEME.bgLight,
                    fontWeight: "600",
                  }}
                >
                  {COLUMNS.map((col, colIndex) => {
                    if (col.id === "no") {
                      return (
                        <td
                          key={col.id}
                          className="p-2 text-center"
                          style={{ color: "var(--theme-primary)" }}
                        >
                          Total
                        </td>
                      );
                    }
                    if (col.id === "pcs") {
                      return (
                        <td
                          key={col.id}
                          className="p-2 text-end"
                          style={{ color: "var(--theme-primary)" }}
                        >
                          {tableData.reduce((sum, row) => {
                            const pcs = parseFloat(
                              row.data.find((cell) => cell.id === "pcs")
                                ?.value || 0,
                            );
                            return sum + (isNaN(pcs) ? 0 : pcs);
                          }, 0)}
                        </td>
                      );
                    }
                    if (col.id === "grWt") {
                      return (
                        <td
                          key={col.id}
                          className="p-2 text-end"
                          style={{ color: "var(--theme-primary)" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const gwt = parseFloat(
                                row.data.find(
                                  (cell) => cell.id === "grWt",
                                )?.value || 0,
                              );
                              return sum + (isNaN(gwt) ? 0 : gwt);
                            }, 0)
                            .toFixed(2)}
                        </td>
                      );
                    }
                    if (col.id === "lsWt") {
                      return (
                        <td
                          key={col.id}
                          className="p-2 text-end"
                          style={{ color: "var(--theme-primary)" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const lwt = parseFloat(
                                row.data.find(
                                  (cell) => cell.id === "lsWt",
                                )?.value || 0,
                              );
                              return sum + (isNaN(lwt) ? 0 : lwt);
                            }, 0)
                            .toFixed(2)}
                        </td>
                      );
                    }
                    if (col.id === "netWt") {
                      return (
                        <td
                          key={col.id}
                          className="p-2 text-end"
                          style={{ color: "var(--theme-primary)" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const nwt = parseFloat(
                                row.data.find(
                                  (cell) => cell.id === "netWt",
                                )?.value || 0,
                              );
                              return sum + (isNaN(nwt) ? 0 : nwt);
                            }, 0)
                            .toFixed(2)}
                        </td>
                      );
                    }
                    if (col.id === "fWt") {
                      return (
                        <td
                          key={col.id}
                          className="p-2 text-end"
                          style={{ color: "var(--theme-primary)" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const fwt = parseFloat(
                                row.data.find(
                                  (cell) => cell.id === "fWt",
                                )?.value || 0,
                              );
                              return sum + (isNaN(fwt) ? 0 : fwt);
                            }, 0)
                            .toFixed(2)}
                        </td>
                      );
                    }
                    if (col.id === "itAmt") {
                      return (
                        <td
                          key={col.id}
                          className="p-2 text-end"
                          style={{ color: "var(--theme-primary)" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const itAmt = parseFloat(
                                row.data.find(
                                  (cell) => cell.id === "itAmt",
                                )?.value || 0,
                              );
                              return sum + (isNaN(itAmt) ? 0 : itAmt);
                            }, 0)
                            .toFixed(2)}
                        </td>
                      );
                    }
                    if (col.id === "othAmt") {
                      return (
                        <td
                          key={col.id}
                          className="p-2 text-end"
                          style={{ color: "var(--theme-primary)" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const othAmt = parseFloat(
                                row.data.find(
                                  (cell) => cell.id === "othAmt",
                                )?.value || 0,
                              );
                              return sum + (isNaN(othAmt) ? 0 : othAmt);
                            }, 0)
                            .toFixed(2)}
                        </td>
                      );
                    }
                    if (col.id === "mrp") {
                      return (
                        <td
                          key={col.id}
                          className="p-2 text-end"
                          style={{ color: "var(--theme-primary)" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const mrp = parseFloat(
                                row.data.find((cell) => cell.id === "mrp")
                                  ?.value || 0,
                              );
                              return sum + (isNaN(mrp) ? 0 : mrp);
                            }, 0)
                            .toFixed(2)}
                        </td>
                      );
                    }
                    if (col.id === "totalAmt") {
                      return (
                        <td
                          key={col.id}
                          className="p-2 text-end fw-bold"
                          style={{
                            color: "var(--theme-primary)",
                            fontSize: "0.9rem",
                          }}
                        >
                          {calculateTotal().toFixed(2)}
                        </td>
                      );
                    }
                    return <td key={col.id} className="p-0"></td>;
                  })}
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <button
            type="button"
            className="btn"
            onClick={() => setShowItemsModal(false)}
            style={{
              backgroundColor: "var(--theme-primary)",
              color: GIRVI_THEME.textColor,
              borderRadius: "8px",
              padding: "8px 16px",
            }}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
      {/* Photo Preview Modal */}
      {showPhotoModal && customerPhotoPreview && (
        <div
          className="modal fade show d-flex align-items-center justify-content-center"
          style={{
            display: "flex",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1050,
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
          onClick={() => setShowPhotoModal(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
            style={{ margin: 0 }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                maxWidth: "600px",
                margin: "auto",
              }}
            >
              <div
                className="modal-header border-0 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: "var(--theme-primary)",
                  padding: "16px 20px",
                }}
              >
                <h5
                  className="modal-title text-white d-flex align-items-center mb-0"
                  style={{ margin: "0" }}
                >
                  <iconify-icon
                    icon="solar:gallery-bold-duotone"
                    className="me-2"
                    style={{ fontSize: "20px" }}
                  />
                  Customer Photo
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowPhotoModal(false)}
                ></button>
              </div>
              <div
                className="modal-body text-center d-flex align-items-center justify-content-center"
                style={{ padding: "20px", minHeight: "300px" }}
              >
                <img
                  src={customerPhotoPreview}
                  alt="Customer Photo"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "500px",
                    borderRadius: "8px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </div>
              <div
                className="modal-footer border-0 d-flex justify-content-end"
                style={{ padding: "16px 20px" }}
              >
                <button
                  type="button"
                  className="btn"
                  onClick={() => {
                    setCustomerPhoto(null);
                    setCustomerPhotoPreview(null);
                    if (customerPhotoInputRef.current) {
                      customerPhotoInputRef.current.value = "";
                    }
                    setShowPhotoModal(false);
                  }}
                  style={{
                    backgroundColor: "var(--theme-primary)",
                    color: GIRVI_THEME.textColor,
                    borderRadius: "8px",
                    padding: "8px 24px",
                  }}
                >
                  Remove Photo
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Item Image Preview Modal */}
      {showItemImageModal && itemImagePreview && (
        <div
          className="modal fade show d-flex align-items-center justify-content-center"
          style={{
            display: "flex",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1050,
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
          onClick={() => setShowItemImageModal(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
            style={{ margin: 0 }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                maxWidth: "600px",
                margin: "auto",
              }}
            >
              <div
                className="modal-header border-0 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: "var(--theme-primary)",
                  padding: "16px 20px",
                }}
              >
                <h5
                  className="modal-title text-white d-flex align-items-center mb-0"
                  style={{ margin: "0" }}
                >
                  <iconify-icon
                    icon="solar:gallery-bold-duotone"
                    className="me-2"
                    style={{ fontSize: "20px" }}
                  />
                  Item Image
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowItemImageModal(false)}
                ></button>
              </div>
              <div
                className="modal-body text-center d-flex align-items-center justify-content-center"
                style={{ padding: "20px", minHeight: "300px" }}
              >
                <img
                  src={itemImagePreview}
                  alt="Item"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "500px",
                    borderRadius: "8px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </div>
              <div
                className="modal-footer border-0 d-flex justify-content-end"
                style={{ padding: "16px 20px" }}
              >
                <button
                  type="button"
                  className="btn"
                  onClick={() => {
                    setItemImage(null);
                    setItemImagePreview(null);
                    if (itemImageInputRef.current) {
                      itemImageInputRef.current.value = "";
                    }
                    setShowItemImageModal(false);
                  }}
                  style={{
                    backgroundColor: "var(--theme-primary)",
                    color: GIRVI_THEME.textColor,
                    borderRadius: "8px",
                    padding: "8px 24px",
                  }}
                >
                  Remove Image
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* User Proof Image Modal */}
      {showUserProofModal && userProofImgPreview && (
        <div
          className="modal fade show d-flex align-items-center justify-content-center"
          style={{
            display: "flex",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1050,
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
          onClick={() => setShowUserProofModal(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
            style={{ margin: 0 }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                maxWidth: "600px",
                margin: "auto",
              }}
            >
              <div
                className="modal-header border-0 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: "var(--theme-primary)",
                  padding: "16px 20px",
                }}
              >
                <h5
                  className="modal-title text-white d-flex align-items-center mb-0"
                  style={{ margin: "0" }}
                >
                  <iconify-icon
                    icon="solar:gallery-bold-duotone"
                    className="me-2"
                    style={{ fontSize: "20px" }}
                  />
                  User Proof Image
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowUserProofModal(false)}
                ></button>
              </div>
              <div
                className="modal-body text-center d-flex align-items-center justify-content-center"
                style={{ padding: "20px", minHeight: "300px" }}
              >
                <img
                  src={userProofImgPreview}
                  alt="User Proof Image"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "500px",
                    borderRadius: "8px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Customer Signature Modal */}
      {showSignatureModal && customerSignaturePreview && (
        <div
          className="modal fade show d-flex align-items-center justify-content-center"
          style={{
            display: "flex",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1050,
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
          onClick={() => setShowSignatureModal(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
            style={{ margin: 0 }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                maxWidth: "600px",
                margin: "auto",
              }}
            >
              <div
                className="modal-header border-0 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: "var(--theme-primary)",
                  padding: "16px 20px",
                }}
              >
                <h5
                  className="modal-title text-white d-flex align-items-center mb-0"
                  style={{ margin: "0" }}
                >
                  <iconify-icon
                    icon="solar:pen-bold-duotone"
                    className="me-2"
                    style={{ fontSize: "20px" }}
                  />
                  Customer Signature
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowSignatureModal(false)}
                ></button>
              </div>
              <div
                className="modal-body text-center d-flex align-items-center justify-content-center"
                style={{ padding: "20px", minHeight: "300px" }}
              >
                <img
                  src={customerSignaturePreview}
                  alt="Customer Signature"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "500px",
                    borderRadius: "8px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddGirvi;
